

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import { Form, Tabs, Table } from 'element-ui'
import PlatformConfig from '@/store/modules/config'
import { UserModule } from '@/store/modules/user'
import request from '@/utils/request'
import $ from 'jquery'
import VueQr from 'vue-qr'
@Component({
  name: 'sysUserList',
  components: {
    Pagination,
    VueQr
  }
})
export default class extends Vue {
  private ceshiVisible:any = false
  private lockSrc:any = require('@/assets/lock.png')
  private auditSrc:any = require('@/assets/audit.png')
  private truckSrc:any = require('@/assets/truck.png')
  private moneySrc:any = require('@/assets/money.png')
  private timeSrc:any = require('@/assets/time.png')
  private shipSrc:any = require('@/assets/ship.png')
  private successSrc:any = require('@/assets/success.png') // 成功图片，用于显示电子提货单结果
  private errorSrc:any = require('@/assets/false.png') // 失败图片，用于显示电子提货单结果
  private qdbanklogo:any = require('@/assets/QDlogo.png') // 青岛银行logo
  private imageRes= PlatformConfig.baseServerUrlApi + '/TCntrBL/UploadEIRIMG'
  private addList:any = require('@/assets/static/city.json')
  private cityList: any = []
  private areaList:any = []
  private province: any = ''
  private city: any = ''
  private area: any = ''
  private goodsName: any = ''
  private shoukuandisabled = false
  private jiaonayajinloading = false
  private feedialogTableVisible = false
  private xiuxixiangfeiamt = 0
  private posttype = 2 // 发票领取方式
  private invtype = 0 // 发票类型
  private count1:any = 0 // 押箱待受理数量
  private count2:any = 0 // 退押待受理数量
  private tableKey = 0; // 表格标识
  private total = 50; // 单据表格条数
  private listLoading = true;
  private holdboxAmt:any = 0 // 押箱金额
  private jujueyuanyin:any = '' // 受理拒绝原因
  private totalprice:any = 0 // 操作费总金额
  private BLID:any = '' // 押箱BLID
  private BLNo:any = '' // 押箱业务号
  private yajincharge:any = '' // 押金的计费受理单ID
  private tableData: any = [] // 押箱记录表格数据
  private remittanceData:any = [] // 汇款记录
  private remittanceDataLoading:any = false // 转账记录加载
  private yajinLoading:any = false // 打印押金条加载
  private yuyuedisabled:any = false
  private yuyueLoading:any = false
  private stepactive:any = 0 // 步骤条控制
  private InvSelectBL:any = [] // 发票抬头
  private dialogTableVisible: any = false // 对话框
  private tuiyadialogVisible: any = false // 选择退押账户对话框
  private AddBankdialogVisible:any = false // 添加银行账户对话框
  private dianzitihuodandialogVisible:any = false // 电子提货单对话框
  private paymentdialogVisible:any = false // 订单支付对话框
  private leveltableData:any = []; // 二级表格数据
  private searchData:any = [] // 单票查询数据
  private checkticket:any = []; // 添加预约
  private priceList:any = [] // 操作费列表
  private corpattnList:any = [] // 客户联系人列表
  private banklist:any = [] // 全部银行信息
  private corpbankList:any = [] // 客户银行列表 退押用
  private chargeList:any = [] // 计费受理单集装箱信息
  private addstate:any = 0 // 添加状态 判断当前是重新添加状态 0为新添加状态  1为返回上一步 不添加状态（暂定）
  private corpAttn:any = '' // 缴纳押金页面联系人名称
  private agreement:any = false // 协议用户数量限制
  private jiaonacaozuofeiloading = false // 缴纳操作费加载中
  private jiaonacaozuofeidisabled = false // 缴纳操作费禁用
  private yajindisabled:any = true // 确认无误缴纳押金按钮禁用
  private depositdisabled:any = true // 下一步按钮禁用开关
  private searchdisabled:any = false // 单票查询按钮禁用
  private corpselectlist:any = false
  private dialogyuanyinVisible:any = false // 退款原因
  private nowstltype:any = 0 // 当前支付方式
  private searchfoem:any = { // 搜索表单

  }
  private invData:any = [] // 发票抬头表格
  private invtotal:any = 0
  private lading:any = [] // 计费受理单显示信息
  private tuiyaform:any = { // 退押客户银行信息表单
    bankID: '', // 银行信息ID
    accountName: '', // 开户行公司名称
    bankName: '', // 开户行
    bankNo: '', // 开户行账号
    isDefault: false, // 是否默认账户
    bankMessage: ''
  }
  private addtuiyaform:any = { // 退押客户银行信息表单
    bankID: '', // 银行信息ID
    accountName: '', // 开户行公司名称
    bankName: '', // 开户行
    bankNo: '', // 开户行账号
    isDefault: false, // 是否默认账户
    bankMessage: ''
  }
  private expressTel = ''
  private expressAttn = ''
  private expressAddr = ''
  private userinfo:any = {} // 登录用户信息
  private options:any= []
  private value:any= []
  private list:any= []
  private addtuiyaformloading = false
  private invloading = false
  private successloading = false // 支付成功按钮
  private url:any = PlatformConfig.baseOnlineUrl + '/#/online/ceshi/'
  private isHaveDefault:any = false // 是否含有默认账户
  private ceshipinjie() {
    this.url = this.url + '307'
    $('#Pcyear').attr('src', this.url)
    this.paymentdialogVisible = true
  }
  private rowdata:any = {}

  // 邮寄地址下拉改变事件
  private addrIDchange(value:any) {
    this.expressAddr = this.addrID
    this.addrselectlist.forEach(ele => {
      if (ele.addrID === value) {
        this.expressTel = ele.mailTel
        this.expressAttn = ele.mailTo
        this.expressAddr = ele.mailAddress
      }
    })
  }
  // 打印押金条
  private print(row:any) {
    this.rowdata = row
    request({
      url: '/TDptCntrBL/GetModel?Id=' + row.blid,
      method: 'GET'
    }).then((res:any) => {
      if (res.code === 200) {
        this.BLID = row.blid
        this.BLNo = res.data.blno
        var data = row
        this.form.vesselCode = data.vesselCode
        this.form.impVoy = data.impVoy // 进口航次
        this.form.corpname = data.corpID.toString()
        this.ruleForm.amt = data.amt // 押箱金额
        this.ruleForm.checkNo = data.checkNo // 支票号
        this.retreatbox.cardNo = data.bankNo
        this.retreatbox.bankName = data.bankName
        this.retreatbox.corpname = data.accountName
        this.retreatbox.tel = data.corpTEL
        this.retreatbox.amt = data.amt
        this.selecttableData = []
        request({
          url: '/TCntrBL/GetCntrCount?MblNo=' + res.data.mblNo,
          method: 'GET'
        }).then((resp:any) => {
          var i = 0
          var cntrCount = resp.data
          res.data.mblNo.split(',').forEach(element => {
            this.selecttableData.push({ mblNo: element, qty: cntrCount[i] })
            i++
          })
          var mblno = ''
          this.selecttableData.forEach(item => {
            mblno += item.mblNo + '*' + item.qty + ','
          })
          if (mblno.length > 0) {
            mblno = mblno.substring(0, mblno.length - 1)
          }
          this.depositdata.mblno = mblno // 提单号
          this.getModel()
        }).catch((response:any) => {
          console.log('失败')
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  // 获取押箱数据 打印押金条
  private async getModel() {
    var _self = this
    // 获取单据信息
    request({
      url: '/TDptCntrBL/GetModel?Id=' + this.BLID,
      method: 'GET'
    }).then((respone:any) => {
      this.depositdata = respone.data
      this.depositdata.dptDate = this.depositdata.dptDate.replace('T', ' ') // 处理时间问题
      switch (this.depositdata.stlType) {
        case 2:
          this.depositdata.shoukuanType = 'POS'
          break
        case 3:
          this.depositdata.shoukuanType = '汇款'
          break
        case 5:
          this.depositdata.shoukuanType = '协议'
          break
      } // 处理付款方式
      this.depositdata.isHeya = this.depositdata.dptType === 1 ? '否' : '是' // 是否合押
      this.depositdata.vesselCode = this.rowdata.vesselCode // 船名代码
      this.depositdata.impVoy = this.rowdata.impVoy // 进口航次
      this.depositdata.blNo = this.BLNo
      this.depositdata.corpAttn = respone.data.corpAttn
      this.corpselectlist.forEach(element => {
        if (element.value === this.rowdata.corpID.toString()) {
          this.depositdata.corpname = element.label // 客户名称
        }
      })
      this.depositdata.totalAmt = this.rowdata.amt // 押箱金额
      this.depositdata.checkNo = this.rowdata.checkNo // 支票号
      var mblno = ''
      this.selecttableData.forEach(item => {
        mblno += item.mblNo + '*' + item.qty + ','
      })
      if (mblno.length > 0) {
        mblno = mblno.substring(0, mblno.length - 1)
      }
      this.depositdata.mblno = mblno // 提单号
      setTimeout(function name() { // 待页面加载完成打印
        _self.printdeposit()
      }, 500)
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  private invhandleCurrentChange() {
    this.getInvData()
  }
  private searchinv() {
    this.getInvData()
  }
  private tuiya() {
    console.log('退押')
  }
  // 查询发票抬头
  private getInvData() {
    // nowstltype 3 为汇款   7 为网银，汇款方式公司只能提交该公司名称的抬头
    if (this.nowstltype === 3) { // 汇款限制
      console.log(this.selectbl)

      // 获取转账记录
      request({
        url: '/TChargeblbsn/GetBSNByChargeID?BLID=' + this.selectbl[0],
        method: 'GET'
      }).then((respone:any) => {
        console.log(respone)
        if (respone.code === 200) {
          if (respone.data.accountName.indexOf('公司') >= 0) {
            request({
              url: '/TCodecorpinv/GetListByTokenCorp?pi=' + this.invlistQuery.pi + '&&ps=' + this.invlistQuery.ps + '&&CorpName=' + respone.data.accountName,
              method: 'GET'
            }).then((respone:any) => {
              this.invData = respone.list
              this.invtotal = respone.total
            }).catch((response:any) => {
              console.log('失败')
            })
            this.invloading = false
            this.InvDialog = true
          } else {
            request({
              url: '/TCodecorpinv/GetListByTokenCorp?pi=' + this.invlistQuery.pi + '&&ps=' + this.invlistQuery.ps + '&&CorpName=' + this.invlistQuery.corpName,
              method: 'GET'
            }).then((respone:any) => {
              this.invData = respone.list
              this.invtotal = respone.total
            }).catch((response:any) => {
              console.log('失败')
            })
            this.invloading = false
            this.InvDialog = true
          }
        } else {
          this.$message({
            type: 'warning',
            message: '提交发票异常'
          })
        }
      }).catch((response:any) => {
        console.log('失败')
      })
    } else if (this.nowstltype === 7) { // 网银，不限制
      request({
        url: '/TCodecorpinv/GetListByTokenCorp?pi=' + this.invlistQuery.pi + '&&ps=' + this.invlistQuery.ps + '&&CorpName=' + this.invlistQuery.corpName,
        method: 'GET'
      }).then((respone:any) => {
        this.invData = respone.list
        this.invtotal = respone.total
      }).catch((response:any) => {
        console.log('失败')
      })
      this.invloading = false
      this.InvDialog = true
    }
  }
  // 发票抬头选择
  private InvSelectionChange(val:any) {
    this.InvSelectBL = []
    for (var i = 0; i < val.length; i++) {
      this.InvSelectBL.push(val[i])
    }
  }
  private paysuccess() {
    this.paymentdialogVisible = false
  }
  private paymentdialogVisibleclose() {
    this.successloading = true
    // this.paymentdialogVisible = false
    request({
      url: '/TChargebl/QueryIsSuccess?ChargeID=' + this.yajincharge,
      method: 'GET'
    }).then((res:any) => {
      if (res.code === 200) {
        // this.$message({
        //   type: 'success',
        //   message: '支付成功'
        // })
        this.successloading = false
        this.paymentdialogVisible = false
        if (this.dialogTableVisible) { // 单票查询
          if (this.danpiaoactiveName === 'third') { // 进行的为第三步
            this.yajinLoading = false // 关闭支付按钮加载状态
            this.yajindisabled = true // 开启支付按钮禁用
            this.depositdisabled = false // 关闭下一步禁用状态
          } else if (this.danpiaoactiveName === 'fourth') { // 进行的为第四步
            this.jiaonacaozuofeiloading = false // 关闭支付加载状态
            this.jiaonacaozuofeidisabled = true // 开启支付禁用状态
            this.nowstltype = 7
            this.getInvData()
          }
        } else { // 退押操作
          this.nowstltype = 7
          this.getInvData()
        }
      } else {
        request({
          url: '/TChargebl/CheckOnlinePay?ChargeID=' + this.yajincharge,
          method: 'GET'
        }).then((res:any) => {
          this.successloading = false
          if (res.code === 200) {
            this.paymentdialogVisible = false
            if (this.dialogTableVisible) { // 单票查询
              if (this.danpiaoactiveName === 'third') { // 进行的为第三步
                this.yajinLoading = false // 关闭支付按钮加载状态
                this.yajindisabled = true // 开启支付按钮禁用
                this.depositdisabled = false // 关闭下一步禁用状态
              } else if (this.danpiaoactiveName === 'fourth') { // 进行的为第四步
                this.jiaonacaozuofeiloading = false // 关闭支付加载状态
                this.jiaonacaozuofeidisabled = true // 开启支付禁用状态
                this.nowstltype = 7
                this.getInvData()
              }
            } else { // 退押操作
              this.nowstltype = 7
              this.getInvData()
            }
          } else {
            this.$message({
              type: 'warning',
              message: res.message
            })
            this.paymentdialogVisible = false
            if (this.danpiaoactiveName === 'third') { // 进行的为第三步
              this.depositdisabled = true // 下一步禁用
              this.yajinLoading = false // 缴纳押金加载关闭
              this.yajindisabled = false // 缴纳押金禁用关闭
            } else { // 进行的为第四步
              this.jiaonacaozuofeidisabled = false
              this.jiaonacaozuofeiloading = false
            }
          }
        }).catch((res:any) => {
          console.log('失败')
        })
      }
    }).catch((res:any) => {
      console.log('失败')
    })
  }
  private remoteMethod(query) {
    if (query !== '' && query.length >= 4) {
      this.addtuiyaformloading = true
      request({
        url: '/TCodecorpbank/GetBankNo?bankNo=' + query,
        method: 'get'
      }).then((res:any) => {
        if (res.code === 200) {
          this.addtuiyaformloading = false
          this.options = res.data
        }
      }).catch((res:any) => {
        console.log('失败')
      })
    } else {
      this.options = []
    }
  }
  private addtuiyaformchange(value) {
    if (typeof value === 'object') {
      this.addtuiyaform.accountName = value.accountName
      this.addtuiyaform.bankName = value.bankName
      this.addtuiyaform.bankNo = value.bankNo
    }
  }
  // 自定义查询
  private autodialogVisible=false
  private jiaotongdialogVisible = false
  private cgargebl = {
    blNo: '',
    blDate: ''
  } // 计费受理单内容
  private depositdata = {
    stlType: 0,
    dptType: 0,
    vesselCode: '',
    impVoy: '',
    corpname: '',
    totalAmt: '',
    checkNo: '',
    mblno: '',
    isHeya: '',
    shoukuanType: '',
    dptDate: '',
    blNo: '',
    corpAttn: ''
  } // 押金数据
  private totalAmt = '' // 计费受理单金额明细
  private amt = 0
  private feeCN:any = '' // 计费受理单费用名称
  private realName:any = '' // 计费受理单真实名称
  private cntrNo:any = '' // 计费受理单箱号
  private corpName = '' // 押金条显示客户名称
  private img:any = require('@/assets/pay.png') // 业务号二维码
  private tableHeight:any = window.innerHeight - 350 // 表格高度
  private selectbl:any = [] // 押箱表格选中BLID
  private selectbldata:any = [] // 押箱表格选中数据
  private corpselect:any = [] // 客户下拉信息
  private remittanceDataSelect:any = [] // 转账记录选中数据
  private ticketMblno:any = '' // 单票查询搜索提单号
  private selecttableData:any = []; // 选中表格
  private dialogVisible:any = false
  private ticketData:any = []; // 单票表格数据
  private activeName:any = 'first' // 当前选中选项卡
  private InvDialog:any = false // 发票抬头对话框
  private danpiaoactiveName:any = 'first'
  private chargeID:any = '567'
  private addrID:any = ''
  private mblno:any = '' // 汇款显示的提单号
  private retreatbox:any = {} // 退箱信息
  // 单票查询参数
   private ruleForm:any = {
     amt: '',
     tCntrIDList: [],
     dptKind: '箱站',
     checkNo: '',
     dptType: '1',
     dptStatus: '0',
     opName: '',
     isSOC: false,
     dptDate: null,
     corpID: '',
     corpname: '',
     corpAttn: '',
     corpTEL: '',
     stlType: '',
     invStatus: 3,
     mblno: '',
     online: ''
   }
  // 分页表单查询参数
  private listQuery = {
    pi: 1,
    ps: 10,
    corpID: null,
    tChangeBLNO: null,
    tCntrBLNO: null,
    dptStatus: -1,
    vessel: null,
    impVoy: null,
    tdeptosBLNO: null
  };
  // 单票查询显示表单
 private form:any = {
   mblNo: '',
   vesselCode: '',
   impVoy: '',
   carrierCode: '',
   boxSum: '',
   releaseState: '',
   corpcode: '',
   corpname: '',
   freeTimePeriod: '',
   freeDueDate: ''
 }
 // 月结免押金限制信息显示
 private limit:any = {
   limitTimes: '', // 次数
   limitCntrs: '', // 集装箱数
   limitBills: '' // 票数
 }
  // 本月次数票数箱数信息显示
  private monthlimit:any = {
    limitTimes: '', // 次数
    limitCntrs: '', // 集装箱数
    limitBills: '' // 票数
  }
  private invlistQuery = {
    pi: 1,
    ps: 10,
    corpName: ''
  }
  // 表单验证
  private rules:any = {
    name: [
      { required: true, message: '请输入活动名称', trigger: 'blur' },
      { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
    ],
    region: [
      { required: true, message: '请选择活动区域', trigger: 'change' }
    ],
    date1: [
      { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
    ],
    date2: [
      { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
    ],
    type: [
      { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
    ],
    resource: [
      { required: true, message: '请选择活动资源', trigger: 'change' }
    ],
    desc: [
      { required: true, message: '请填写活动形式', trigger: 'blur' }
    ]
  }
  private posttypechange(value:any) {
    if (value === 1) { // 邮寄
      console.log('邮寄')
    } else { // 自取
      console.log('自取')
    }
  }
  // 单票查询自动转大写
  private ticketMblnoInput() {
    this.ticketMblno = this.ticketMblno.toUpperCase()
  }
  // 收费方式下拉改变实践
  private stlTypeChange(value:any) {
    if (this.ruleForm.isSOC === true) {
      this.ruleForm.stlType = ''
      this.$message.error('选择客户自备后不需选择收费方式')
      return false
    }
    if (this.dialogTableVisible) {
      this.ruleForm.amt = this.selectbldata[0].amt
    }
    this.yajindisabled = false
    this.depositdisabled = false
    // 汇款方式
    if (this.ruleForm.stlType === '3') { // 汇款
      if (this.dialogTableVisible) { // 单票查询打开状态
        if (this.danpiaoactiveName === 'third') { // 缴纳押金
          console.log(this.selectbldata)
          this.queryBankDetailed(new Date().setDate(new Date().getDate() - 30), new Date(), this.selectbldata[0].amt)
        } else if (this.danpiaoactiveName === 'fourth') { // 操作费
          this.queryBankDetailed(new Date().setDate(new Date().getDate() - 30), new Date(), this.totalprice)
        }
      } else { // 修洗箱费
        this.queryBankDetailed(new Date().setDate(new Date().getDate() - 30), new Date(), this.xiuxixiangfeiamt)
      }
    }
    if (this.ruleForm.stlType === '5') { // 协议
      request({
        url: '/TCodecorp/GetTCodecorpDetailsAsync?Id=' + this.selectbldata[0].corpID
      }).then((respone:any) => {
        if (respone.data.stlType !== '协议') {
          this.ruleForm.stlType = '2'
          this.$message.error('该客户为非协议用户，不允许选择协议收费方式')
        } else {
          // this.form.corpcode = respone.data.organizeNo // 修改申请押箱公司代码
          // this.ruleForm.checkNo = respone.data.checkNo // 支票号
          this.limit.limitTimes = respone.data.limitTimes // 次数
          this.limit.limitBills = respone.data.limitBills // 票数
          this.limit.limitCntrs = respone.data.limitCntrs // 集装箱数
          request({
            url: '/TDptCntrBL/GetCorpBills?CorpID=' + this.selectbldata[0].corpID
          }).then((res:any) => {
            this.monthlimit.limitTimes = res.data.limitTimes // 次数
            this.monthlimit.limitBills = res.data.limitBills // 票数
            this.monthlimit.limitCntrs = res.data.limitCntrs // 集装箱数
            request({
              url: '/TCntrBL/GetCntrByDptBLID?BLID=' + this.selectbldata[0].blid
            }).then((cntr:any) => {
              if (cntr.code === 200) {
                var mblno:any = []
                cntr.data.forEach(item => {
                  var isSuccess = true
                  mblno.forEach(ele => {
                    if (item.mblNo === ele) {
                      isSuccess = false
                    }
                  })
                  if (isSuccess) {
                    mblno.push(item.mblNo)
                  }
                })
                // 判断本月使用次数加上本次使用次数是否超过限制次数
                if (this.monthlimit.limitTimes + 1 > this.limit.limitTimes ||
                this.monthlimit.limitBills + mblno.length > this.limit.limitBills ||
                this.monthlimit.limitCntrs + cntr.data.length > this.limit.limitCntrs) {
                  this.agreement = false
                } else {
                  this.agreement = true
                  this.ruleForm.amt = '0' // 修改押箱金额为0
                  this.yajindisabled = true
                  this.depositdisabled = false
                }
              } else {
                this.$message({
                  type: 'warning',
                  message: cntr.message
                })
              }
            }).catch((res:any) => {
              console.log('失败')
            })
          }).catch((res:any) => {
            console.log('失败')
          })
        }
        // this.ruleForm.corpTEL = respone.data.tel // 修改电话
      }).catch((response:any) => {
        console.log('失败')
      })
    }
    if (this.ruleForm.stlType === '8') { // 免押
      this.ruleForm.amt = '0' // 修改押箱金额为0
      this.yajindisabled = true
      this.depositdisabled = false
    }
  }
  // 查询转账记录
  private queryBankDetailed(startDate, endDate, amt) {
    this.remittanceDataLoading = true // 打开表格加载状态
    let startDate1 = new Date(startDate)
    let endDate1 = new Date(endDate)
    // 这里查询转账记录
    let bankNos = ''
    console.log(this.banklist)
    this.banklist.forEach(item => {
      bankNos += item.bankNo + '|'
    })
    let corpID = this.userinfo.copId
    var params = {
      serialNo: '12345678901234567890',
      accountNo: '802850200195458',
      beginDate: startDate1.getFullYear().toString() + this.conver(startDate1.getMonth() + 1) + this.conver(startDate1.getDate()),
      endDate: endDate1.getFullYear().toString() + this.conver(endDate1.getMonth() + 1) + this.conver(endDate1.getDate()),
      beginAmount: amt.toFixed(2),
      endAmount: amt.toFixed(2),
      bankNos: bankNos,
      // corpID: corpID,
      blno: this.selectbldata[0].mblNo,
      turnPageShowNum: 1000,
      turnPageBeginPos: 1 // 起始条数
    }
    request({
      url: '/TChargebl/GetBankDetailedOnline',
      method: 'POST',
      params: params
    }).then((res:any) => {
      if (res.code === 200) {
        // 获取系统中最近三天的转账记录
        if (res.data.list.length === 0) {
          this.$message({
            type: 'warning',
            message: '未找到退押账户的转账记录'
          })
        }
        this.remittanceData = res.data.list // 加载数据
        this.remittanceDataLoading = false // 数据加载完成，关闭加载状态
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
        this.remittanceDataLoading = false // 数据加载完成，关闭加载状态
      }
    }).catch((res:any) => {
      console.log('失败')
    })
  }
  private queryExCheckDate=[]
  // 单据删除
  private deletedpt() {
    if (this.selectbldata.length === 0) {
      this.$message({
        type: 'warning',
        message: '请选择数据后操作'
      })
      return false
    }
    request({
      url: '/TDptCntrBL?BLID=' + this.selectbldata[0].blid,
      method: 'DELETE'
    }).then((res:any) => {
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '删除成功'
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  // 表单数据搜索
  private handleFilter() {
    this.getList()
  }
  // 勾选数据
  private remittanceDataSelectionChange(val:any) {
    this.remittanceDataSelect = []
    this.remittanceDataSelect = val
  }
  // 高级查询
  private senior() {
    this.dialogVisible = false
    this.getList()
  }
  // 关闭高级查询对话框
  private handleClose() {
    this.dialogVisible = false
  }
  // 查看详情
  private handleDateils(data: any) {
    var router = this.$router
    router.push({
      path: '/holdBoxList/edit/' + data.blid,
      params: {
        id: data.blid
      }
    })
  }
  // 表格分页
  private handleCurrentChange() {
    this.getList()
  }
  // 单票查询切换选项卡
  private handleClick() {
    switch (this.activeName) {
      case 'first':
        this.listQuery.dptStatus = -1
        break
      case 'second':
        this.listQuery.dptStatus = 0
        break
      case 'third':
        this.listQuery.dptStatus = 1
        break
      case 'fourth':
        this.listQuery.dptStatus = 2
        break
      case 'fifth':
        this.listQuery.dptStatus = 3
        break
      case 'sixth':
        this.listQuery.dptStatus = 4
        break
      case 'seventh':
        this.listQuery.dptStatus = 5
        break
      case 'eighth':
        this.listQuery.dptStatus = 6
        break
      case 'ninth':
        this.listQuery.dptStatus = 7
        break
      case 'tenth':
        this.listQuery.dptStatus = 11
        break
    }
    this.getList()
  }
  // 押箱信息上一步
  private yaxiangxinxi() {
    this.danpiaoactiveName = 'first'
    this.stepactive = 0
  }
  // 押金上一步
  private yajinup() {
    this.danpiaoactiveName = 'second'
    this.stepactive = 1
  }
  // 操作费上一步
  private caozuofeiup() {
    this.danpiaoactiveName = 'third'
    this.stepactive = 1
  }
  // 导出excel
  private ExportExcel() {
    request({
      url: '/Xlsx/ExportHoldBox',
      method: 'POST',
      data: this.tableData
    }).then((respone:any) => {
      window.location.href = respone.data
      if (respone.code === 200) {
        this.$message({
          message: '导出成功',
          type: 'success'
        })
      } else {
        this.$message.error(respone.message)
      }
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  // 单票查询
  private ticketButton() {
    if (this.ruleForm.stlType !== '' && this.tuiyaform.bankID !== '') {
      this.yajindisabled = false
    } else {
      this.yajindisabled = true
    }
    if (this.selectbldata.length === 0) { // 如未选中，则为新建单据，出现重复需提醒
      this.addstate = 0 // 添加状态为零为新添加状态
      this.yuyueLoading = false
      this.yuyuedisabled = false
      this.dialogTableVisible = true
      this.danpiaoactiveName = 'first'
      // 清空所有数据
      // 单票查询表单重置
      this.ticketMblno = 'OOLU'
      this.form.mblNo = ''
      this.form.vesselCode = ''
      this.form.impVoy = ''
      this.form.carrierCode = ''
      this.form.boxSum = ''
      this.form.releaseState = ''
      // 清空箱子信息
      this.leveltableData = []
      // 清空选中提单信息
      this.selecttableData = []
      // 录入押箱信息表单重置
      this.ruleForm.corpID = ''
      this.ruleForm.isSOC = false
      this.ruleForm.stlType = ''
      // this.ruleForm.checkNo = ''
      this.ruleForm.amt = ''
      this.tuiyaform.bankID = ''
      this.tuiyaform.accountName = ''
      this.tuiyaform.bankName = ''
      this.tuiyaform.bankNo = ''
      this.priceList = [] // 操作费的表格
      this.stepactive = 0 // 将进度条重置至第一个
    } else { // 选中数据，继续办单
      if (this.selectbldata.length !== 1) {
        this.$message({
          type: 'warning',
          message: '请选择一票进行操作'
        })
      } else { // 否则为选择一票的操作，首先判断单据状态
        this.BLID = this.selectbldata[0].blid
        this.BLNo = this.selectbldata[0].blno
        this.corpAttn = this.selectbldata[0].corpAttnCN
        // 获取单据第一个提单号，用户汇款提示用户摘要填入
        request({
          url: '/TDptCntrBL/GetFirstMBLNoByBLID?BLID=' + this.selectbldata[0].blid
        }).then((respone:any) => {
          if (respone.code === 200) {
            this.mblno = respone.data
          }
        }).catch((res:any) => {
          console.log('失败')
        })
        // 获取单据当前步骤
        request({
          url: '/TDptCntrBL/GetOnlineStep?BLID=' + this.selectbldata[0].blid
        }).then((respone:any) => {
          if (respone.code === 3) { // 继续第三步操作
            this.ruleForm.amt = respone.data.dptAmt
            this.ruleForm.dptType = respone.data.dptType
            this.corpAttn = respone.data.corpAttn
            this.dialogTableVisible = true
            this.danpiaoactiveName = 'third'
            this.stepactive = 1
            // }
          } else if (respone.code === 4) { // 继续第四步操作
            this.jiaonacaozuofeiloading = false // 关闭支付加载状态
            this.jiaonacaozuofeidisabled = false // 关闭支付禁用状态
            // 生成操作费列表
            request({
              url: '/TCntrBL/GetCntrByDptBLID?BLID=' + this.selectbldata[0].blid,
              method: 'GET'
            }).then((respone:any) => {
              if (respone.code === 200) {
                request({
                  url: '/TCodecntrtype/GetCntrList',
                  method: 'GET'
                }).then((res:any) => {
                  var cntrtype = res.data
                  // 拼接集装箱信息，还需要箱型对应的价格，去箱型表对比
                  var cntrList:any = []
                  var totalprice = 0
                  for (var i = 0; i < respone.data.length; i++) {
                    if (respone.data[i].isSOC !== true) {
                      for (var k = 0; k < cntrtype.length; k++) {
                        var type = respone.data[i].cntrSize + respone.data[i].cntrType
                        if (type === cntrtype[k].cntrNo) {
                          cntrList.push({ cntrType: cntrtype[k].cntrNo, cntrNo: respone.data[i].cntrNo, price: cntrtype[k].czfPrice.toFixed(2), mblNo: respone.data[i].mblNo })
                          totalprice += cntrtype[k].czfPrice
                        }
                      }
                    }
                  }
                  let mblNoList = []
                  // 统计提单号数量
                  respone.data.forEach(item => {
                    if (mblNoList.length === 0) {
                      mblNoList.push(item.mblNo)
                    } else {
                      if (!mblNoList.includes(item.mblNo)) {
                        mblNoList.push(item.mblNo)
                      }
                    }
                  })
                  // 遍历提单号，按照每篇每20T50进行收费
                  mblNoList.forEach(mblNo => {
                    // 2024-12-24修改东港协议客户也需要收取代理操作费，每票固定50元
                    // 中远协议不需要支付
                    // 如果既是中远协议又是东港协议，根据具体公司来收费，现有两家  青岛辉浩国际物流有限公司按照中远协议（无需收费）青岛瑞琪翔运物流有限公司按照东港协议（需收费）


                    // 区分三种情况
                    // 不是任何协议，按照原方式收费
                    let FilterList = respone.data.filter(item => item.mblNo === mblNo && item.carrierCode === 'OOL')
                    console.log(FilterList)
                    if (!this.form.isAgmt && !this.form.isDGAgmt) {
                      if (FilterList.length > 0) {
                        let SCount = FilterList.filter(item => item.cntrSize === 20).length
                        let LCount = FilterList.filter(item => item.cntrSize === 40 || item.cntrSize === 45).length
                        let TEU = SCount + LCount * 2
                        let curprice = Math.ceil(TEU / 20) * 50
                        cntrList.push({ mblNo: mblNo, cntrNo: '代理操作费', cntrType: TEU + 'T', price: curprice.toFixed(2) })
                        totalprice += curprice
                      }
                    }
                    // 既是中远又是东港协议 并且当前选择的协议为东港协议时按照东港协议收费  或者仅是东港协议(未选择按照东港协议使用)  按照每票50元收取
                    else if ((this.form.isAgmt && this.form.isDGAgmt && (this.form.agmtType === 1 || this.form.agmtType === null)) || (this.form.isDGAgmt && this.form.isAgmt != true)) {
                      if (FilterList.length > 0) {
                        let SCount = FilterList.filter(item => item.cntrSize === 20).length
                        let LCount = FilterList.filter(item => item.cntrSize === 40 || item.cntrSize === 45).length
                        let TEU = SCount + LCount * 2
                        let curprice = 50
                        cntrList.push({ mblNo: mblNo, cntrNo: '代理操作费', cntrType: TEU + 'T', price: curprice.toFixed(2) })
                        totalprice += curprice
                      }
                    }
                    // let FilterList = respone.data.filter(item => item.mblNo === mblNo && item.carrierCode === 'OOL' && item.isDGAgreement === false && item.isZYAgreement === false)
                    // if (FilterList.length > 0) {
                    //   let SCount = FilterList.filter(item => item.cntrSize === 20).length
                    //   let LCount = FilterList.filter(item => item.cntrSize === 40 || item.cntrSize === 45).length
                    //   let TEU = SCount + LCount * 2
                    //   let curprice = Math.ceil(TEU / 20) * 50
                    //   cntrList.push({ mblNo: mblNo, cntrNo: '代理操作费', cntrType: TEU + 'T', price: curprice.toFixed(2) })
                    //   totalprice += curprice
                    // }
                  })
                  cntrList.push({ cntrNo: '合计', cntrType: cntrList.filter(item => item.mblNo).length, price: totalprice.toFixed(2) })
                  this.priceList = cntrList
                  this.totalprice = totalprice
                  this.danpiaoactiveName = 'fourth'
                  this.stepactive = 2
                  this.dialogTableVisible = true
                }).catch((response:any) => {
                  console.log('失败')
                })
              } else {
                this.$message.error(respone.message)
              }
            }).catch((response:any) => {
              console.log('失败')
            })
          } else {
            this.$message({
              type: 'warning',
              message: respone.message
            })
          }
        }).catch((response:any) => {
          console.log('失败')
        })
      }
    }
  }
  // 单据表格选中
  private handleSelectionChange(val:any) {
    this.selectbl = [] // 选中ID
    this.selectbldata = [] // 选中行数据
    for (var i = 0; i < val.length; i++) {
      this.selectbl.push(val[i].blid)
      this.selectbldata.push(val[i])
    }
    console.log(this.selectbl)
  }
  // 查询单票
  private searchticket() {
    this.searchdisabled = true // 点击按钮禁用按钮，加载完毕后再开启
    this.form.mblNo = ''
    this.form.vesselCode = ''
    this.form.impVoy = ''
    this.form.carrierCode = ''
    this.form.boxSum = ''
    this.form.releaseState = ''
    this.getTicketList()
  }

  /// 添加联系人
  private dialogContactsVisible=false;
  private formLabelWidth = '80px';
  private contactsForm={
    attnCn: '',
    sex: '1',
    tel: '',
    cell: '',
    email: '',
    fax: '',
    dept: '',
    job: '',
    corpID: ''
  }
  private eirinedx = -1
  private savemblno(data: any) {
    this.eirinedx = data
  }
  private handleAvatarSuccess(res, file) {
    if (res.code === 200) {
      this.selecttableData[this.eirinedx].dianzi = true
      request({
        url: '/TCntrBL/UpdateEIRIMG?mblNo=' + this.selecttableData[this.eirinedx].mblNo + '&&path=' + res.info,
        method: 'PUT'
      }).then((respone:any) => {
        if (respone.code === 200) {
          this.$message({
            type: 'success',
            message: '上传成功'
          })
        } else {
          this.$message({
            type: 'warning',
            message: respone.message
          })
        }
      }).catch((response:any) => {
        console.log('失败')
      })
    }
  }
  private beforeAvatarUpload(file) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
    const isLt2M = file.size / 1024 / 1024 < 5

    if (!isJPG) {
      this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!')
    }
    if (!isLt2M) {
      this.$message.error('上传头像图片大小不能超过 5MB!')
    }
    return isJPG && isLt2M
  }
  private addContacts() {
    this.dialogContactsVisible = true
    this.contactsForm.attnCn = ''
    this.contactsForm.sex = '1'
    this.contactsForm.tel = ''
    this.contactsForm.cell = ''
  }
  private saveContacts(formName) {
    (this.$refs[formName] as Form).validate((valid) => {
      if (valid) {
        request({
          url: '/TCodecorpattn',
          method: 'POST',
          data: this.contactsForm
        }).then((respone:any) => {
          if (respone.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.dialogContactsVisible = false
            request({
              url: '/TCodecorpattn/GetTCodecorpattnDetailsByCorpID?Id=' + this.contactsForm.corpID
            }).then((respone:any) => {
              this.corpattnList = respone.data
              this.ruleForm.corpAttn = ''
              this.ruleForm.corpTEL = ''
            }).catch((response:any) => {
              console.log('失败')
            })
          } else {
            this.$message.error(respone.message)
          }
        }).catch((response:any) => {
          console.log('失败')
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }
  private eirstatus = true
  // 添加至押箱列表
  private addtobox() {
    if (this.form.mblNo === '') {
      this.$message({
        message: '请搜索后添加',
        type: 'warning'
      })
      return
    }
    if (this.form.corpname === '' || this.form.corpcode === '') {
      this.$message({
        message: '请输入押箱公司资料后操作',
        type: 'warning'
      })
      return
    }
    for (var k = 0; k < this.selecttableData.length; k++) {
      if (this.form.mblNo === this.selecttableData[k].mblNo) {
        this.$message({
          message: '当前提单号已存在，不允许重复添加',
          type: 'warning'
        })
        return
      }
    }
    if (!this.goodsName) {
      this.$message({
        message: '请输入货名后操作',
        type: 'warning'
      })
      return
    }
    if (!this.province) {
      this.$message({
        message: '请选择省后操作',
        type: 'warning'
      })
      return
    }
    if (!this.city) {
      this.$message({
        message: '请选择市后操作',
        type: 'warning'
      })
      return
    }
    if (!this.area) {
      this.$message({
        message: '请选择区后操作',
        type: 'warning'
      })
      return
    }
    var tCntrIDList = []
    for (var i = 0; i < this.leveltableData.length; i++) {
      tCntrIDList.push(this.leveltableData[i].cntrID)
    }
    // 锁箱原因（存在锁箱时拼接各箱锁箱原因）
    var lockedReason = ''
    this.leveltableData.forEach(element => {
      if (element.lockedReason) {
        lockedReason += element.lockedReason
      }
    })
    // var Params = []
    // var date = new Date()
    // var year = date.getFullYear()
    // var month = date.getMonth() + 1
    // var day = date.getDate()
    // var hour = date.getHours()
    // var minute = date.getMinutes()
    // var second = date.getSeconds()
    // var nowdatetime = year + '-' + this.conver(month) + '-' + this.conver(day) + ' ' + this.conver(hour) + ':' + this.conver(minute) + ':' + this.conver(second)
    // date.setMonth(date.getMonth() - 1) // 这里的1就是你要加的天数，减也可以。年、月会相应加上去，值得注意的是date.getMonth()得到的月份比实际月份小1
    // Params.push({
    //   billNo: this.form.mblNo, // 提单号
    //   startTime: date.getFullYear() + '-' + this.conver(date.getMonth() + 1) + '-' + this.conver(date.getDate()) + ' ' + this.conver(hour) + ':' + this.conver(minute) + ':' + this.conver(second), // 更新时间开始时间, 精确到秒
    //   endTime: nowdatetime, // 更新时间结束时间, 精确到秒
    //   uploadTime: date.getFullYear() + '-' + this.conver(date.getMonth() + 1) + '-' + this.conver(date.getDate()) + ' ' + this.conver(hour) + ':' + this.conver(minute) + ':' + this.conver(second) // 上传时间
    // })
    // EIR获取校验不需要了
    // request({
    //   url: '/TChargebl/EirHoldBoxApply',
    //   method: 'POST',
    //   data: Params
    // }).then((res:any) => {
    //   if (res.code === 200) {
    //     if (res.data.success === true) {
    //       if (res.data.message.list.length === 0) {
    //         this.$message({
    //           type: 'warning',
    //           message: '拉取电子提货单失败，请手动上传扫描照片'
    //         })
    this.selecttableData.push(
      { 
        mblNo: this.form.mblNo, 
        qty: this.form.boxSum, 
        cntrID: this.leveltableData[0].cntrID, 
        tCntrIDList: tCntrIDList, 
        vessel: this.searchData.data[0].vessel, 
        vesselEN: this.searchData.data[0].vesselEN, 
        impVoy: this.searchData.data[0].impVoy, 
        dianzi: false, 
        eirstatus: true, 
        carrierCode: this.form.carrierCode, 
        LockedReason: lockedReason, // 锁箱原因
        goodsName: this.goodsName,
        province: this.province,
        city: this.city,
        area: this.area
      }
    )
    this.selecttableData[this.selecttableData.length - 1].dianzi = false
    //         this.lading = []
    //       } else {
    //         this.$message({
    //           type: 'success',
    //           message: res.data.message.msg
    //         })
    //         var laddata = res.data.message.list[0]
    //         if (laddata.voyageNo !== this.form.impVoy) {
    //           this.$message({
    //             type: 'warning',
    //             message: '电子EIR海关航次不一致'
    //           })
    //           this.eirstatus = false
    //           this.selecttableData.push({ mblNo: this.form.mblNo, qty: this.form.boxSum, cntrID: this.leveltableData[0].cntrID, tCntrIDList: tCntrIDList, vessel: this.searchData.data[0].vessel, vesselEN: this.searchData.data[0].vesselEN, impVoy: this.searchData.data[0].impVoy, dianzi: false, eirstatus: false })
    //           return false
    //         }
    //         if (laddata.vesselEName !== this.form.vesselEN) {
    //           this.$message({
    //             type: 'warning',
    //             message: '英文船名不一致'
    //           })
    //           this.eirstatus = false
    //           this.selecttableData.push({ mblNo: this.form.mblNo, qty: this.form.boxSum, cntrID: this.leveltableData[0].cntrID, tCntrIDList: tCntrIDList, vessel: this.searchData.data[0].vessel, vesselEN: this.searchData.data[0].vesselEN, impVoy: this.searchData.data[0].impVoy, dianzi: false, eirstatus: false })
    //           return false
    //         }
    //         if (laddata.applyDepositCoName !== this.form.corpname) {
    //           this.$message({
    //             type: 'warning',
    //             message: '客户名称不一致'
    //           })
    //           this.eirstatus = false
    //           this.selecttableData.push({ mblNo: this.form.mblNo, qty: this.form.boxSum, cntrID: this.leveltableData[0].cntrID, tCntrIDList: tCntrIDList, vessel: this.searchData.data[0].vessel, vesselEN: this.searchData.data[0].vesselEN, impVoy: this.searchData.data[0].impVoy, dianzi: false, eirstatus: false })
    //           return false
    //         }
    //         if (laddata.applyDepositCoCode !== this.form.corpcode) {
    //           this.$message({
    //             type: 'warning',
    //             message: '申请押箱公司代码不一致'
    //           })
    //           this.eirstatus = false
    //           this.selecttableData.push({ mblNo: this.form.mblNo, qty: this.form.boxSum, cntrID: this.leveltableData[0].cntrID, tCntrIDList: tCntrIDList, vessel: this.searchData.data[0].vessel, vesselEN: this.searchData.data[0].vesselEN, impVoy: this.searchData.data[0].impVoy, dianzi: false, eirstatus: false })
    //           return false
    //         }
    //         this.selecttableData.push({ mblNo: this.form.mblNo, qty: this.form.boxSum, cntrID: this.leveltableData[0].cntrID, tCntrIDList: tCntrIDList, vessel: this.searchData.data[0].vessel, vesselEN: this.searchData.data[0].vesselEN, impVoy: this.searchData.data[0].impVoy, dianzi: false, eirstatus: true })
    //         this.selecttableData[this.selecttableData.length - 1].dianzi = true
    //       }
    //     } else {
    //       this.$message({
    //         type: 'warning',
    //         message: '拉取失败'
    //       })
    //     }
    //   }
    // }).catch((response:any) => {
    //   console.log('失败')
    // })
  }
  // 单票查询删除
  private dellist(index:any) {
    this.selecttableData.splice(index, 1)
  }
  // 调取电子提货单
  private dianzi(data:any) {
    var Params = []
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hour = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()
    var nowdatetime = year + '-' + this.conver(month) + '-' + this.conver(day) + ' ' + this.conver(hour) + ':' + this.conver(minute) + ':' + this.conver(second)
    date.setMonth(date.getMonth() - 1) // 这里的1就是你要加的天数，减也可以。年、月会相应加上去，值得注意的是date.getMonth()得到的月份比实际月份小1
    Params.push({
      billNo: data.mblNo, // 提单号
      startTime: date.getFullYear() + '-' + this.conver(date.getMonth() + 1) + '-' + this.conver(date.getDate()) + ' ' + this.conver(hour) + ':' + this.conver(minute) + ':' + this.conver(second), // 更新时间开始时间, 精确到秒
      endTime: nowdatetime, // 更新时间结束时间, 精确到秒
      uploadTime: date.getFullYear() + '-' + this.conver(date.getMonth() + 1) + '-' + this.conver(date.getDate()) + ' ' + this.conver(hour) + ':' + this.conver(minute) + ':' + this.conver(second) // 上传时间
    })
    request({
      url: '/TChargebl/EirHoldBoxApply',
      method: 'POST',
      data: Params
    }).then((res:any) => {
      if (res.code === 200) {
        if (res.data.message.list.length === 0) {
          this.$message({
            type: 'warning',
            message: '拉取失败'
          })
          this.lading = []
        } else {
          this.$message({
            type: 'success',
            message: res.data.message.msg
          })
          this.lading = res.data.message.list
          var laddata = this.lading[0]
          // if (this.lading.vesselEName !== this.form.vesselCode) {

          // }
          this.dianzitihuodandialogVisible = true // 打开对话框
        }
      }
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  // 单票查询 下一步
  private yuyue() {
    console.log(this.selecttableData)
    if (this.selecttableData.length < 1) {
      this.$message({
        message: '请添加操作列表后操作',
        type: 'warning'
      })
    } else {
      // var isEir = true
      // this.selecttableData.forEach(ele => {
      //   if (ele.eirstatus === false) {
      //     isEir = false
      //   }
      // })
      // if (!isEir) {
      //   this.$message({
      //     type: 'warning',
      //     message: '电子提货单与押箱信息不匹配，无法继续'
      //   })
      //   return false
      // }
      console.log(this.NoDepositRequiredCarrier)
      console.log(this.selecttableData)
      let EmptyCodeList = this.selecttableData.filter(item => {
        return (item.VerificationCode === undefined || item.VerificationCode === '' || item.VerificationCode === null) && !this.NoDepositRequiredCarrier.includes(item.carrierCode)
      })
      console.log(EmptyCodeList)
      // 船公司代码为OOL且锁箱原因不为空时，即使是中远协议也需要填写校验码
      let isOOLLocked = this.selecttableData.some(item => {
        return item.carrierCode === 'OOL' && item.LockedReason !== undefined && item.LockedReason !== null && item.LockedReason !== ''
      })
      // 非中远协议 或者双协议使用东港协议 的验证码必填
      if (EmptyCodeList.length > 0 && (this.form.isAgmt !== true || this.form.agmtType === 1 || isOOLLocked)) {
        this.$message({
          message: '请填写校验码后操作',
          type: 'warning'
        })
        return false
      }
      // 非中远协议或者双协议使用东港协议的 必填8位
      if ( this.form.isAgmt !== true || this.form.agmtType === 1 || isOOLLocked) {
        let isSuccess = true
        var pattern = /^[0-9]{8}$/
        this.selecttableData.filter(item => {
          return !this.NoDepositRequiredCarrier.includes(item.carrierCode)
        }).forEach(item => {
          if (pattern.test(item.VerificationCode) === false) {
            isSuccess = false
          }
          console.log(item.VerificationCode)
        })
        console.log(isSuccess)
        if (!isSuccess) {
          this.$message({
            message: '校验码请填写8位数字',
            type: 'warning'
          })
          return false
        }
      }
     

      this.yuyueLoading = true
      if (this.selecttableData.length === 1) { // 判断整押合押
        this.ruleForm.dptType = '1'
      } else {
        this.ruleForm.dptType = '2'
      }
      // var isSuccess = true
      // this.selecttableData.forEach(element => {
      //   if (element.dianzi === false) {
      //     isSuccess = false
      //   }
      // })
      // if (!isSuccess) {
      //   this.$message({
      //     type: 'warning',
      //     message: '没有电子提货单，请上传提货单照片'
      //   })
      //   return false
      // }
      // 添加单据
      var mblno = ''
      this.selecttableData.forEach(element => {
        mblno += element.mblNo + ','
      })
      mblno = mblno.substring(0, mblno.length - 1)

      // 首先判断是否为自备箱
      request({
        url: '/TCntrBL/GetIsSocBymblNo?mblnos=' + mblno,
        method: 'GET'
      }).then((result:any) => {
        if (result.code === 200) {
          this.ruleForm.isSOC = true
        } else if (result.code === 201) {
          this.ruleForm.isSOC = false
        } else {
          this.$message({
            type: 'warning',
            message: '获取失败'
          })
          return false
        }
        this.ruleForm.holdList = this.selecttableData // 单票查询提单信息加入对象中
        this.ruleForm.corpID = this.userinfo.copId
        this.ruleForm.amt = '0'
        this.ruleForm.dptStatus = 1
        this.ruleForm.online = 1
        request({
          url: '/TDptCntrBL',
          method: 'PUT',
          data: this.ruleForm
        }).then((respone:any) => {
          this.yuyueLoading = false
          if (respone.code === 200) {
            var dptinfo = respone.data.split(',')
            this.BLID = dptinfo[0] // 记录这一票的BLID
            this.BLNo = dptinfo[1] // 记录这一票的BLNo
            this.dialogTableVisible = false
            this.getList()
            if (respone.message) {
              this.$message({
                type: 'success',
                message: respone.message
              })
            }else{
              this.$message({
                type: 'success',
                message: '添加成功'
              })
            }
          } else {
            this.$message.error(respone.message)
          }
        }).catch((response:any) => {
          console.log('失败')
        })
      }).catch((result:any) => {
        console.log('失败')
      })
    }
  }
  // 客户自备开关
  private isSOCChange(value:any) {
    if (value === true) {
      this.ruleForm.stlType = '' // 选择客户自备时将收费方式置空
    }
  }
  // 录入押箱信息
  private submit() {
    // 根据选择的客户获取对应的银行信息
    request({
      url: '/TCodecorpbank/GetTCodecorpbankDetailsByCorpID?Id=' + this.userinfo.copId
    }).then((respone:any) => {
      this.corpbankList = [] // 清空历史数据
      var corpbankList = respone.data // 首先拿到全部数据
      corpbankList.forEach(element => {
        if (element.isDefault === true) {
          this.corpbankList.push(element)
        }
      })
      if (this.corpbankList.length === 0) {
        this.corpbankList = respone.data // 重新刷新下拉列表，确保获取最新数据
      }
    }).catch((response:any) => {
      console.log('失败')
    })
    this.danpiaoactiveName = 'third'
    this.stepactive = 1
    // this.dialogTableVisible = false
  }
  // 时间补零方法
  private conver(s) {
    return s < 10 ? '0' + s : s
  }
  // 产生单据，缴纳押金
  private jiaonayajin() {
    // 这里总思路：1.首先判断客户自备，为true，那么将不产生计费受理单，不缴费，不打印押金条，收费方式为空
    // 2.为false就为网银
    this.yajinLoading = true // 打开加载状态
    if (this.ruleForm.stlType === '3') { // 收费方式为汇款情况
      if (this.remittanceData.length === 0 || this.remittanceDataSelect.length === 0) { // 数据为零提示请选择转账记录
        this.$message({
          type: 'warning',
          message: '请选择转账记录'
        })
        this.yajinLoading = false // 关闭加载
      } else {
        var totalAmt:number = 0
        this.remittanceDataSelect.forEach(element => {
          totalAmt += parseFloat(element.transferAmt)
        })
        if (totalAmt !== parseFloat(this.ruleForm.amt)) {
          this.$message({
            type: 'warning',
            message: '选择金额金额不匹配'
          })
          this.yajinLoading = false // 关闭加载
          return false
        }
        // 全部通过后首先生成计费受理单
        request({
          url: '/TChargebl?TDptCntrBlid=' + this.selectbldata[0].blid + '&&type=' + encodeURI('押金'),
          method: 'PUT'
        }).then((respone:any) => {
          if (respone.code === 200) {
            this.yajincharge = respone.data // 记录押金的计费受理单ID
            var data = this.remittanceDataSelect
            var params = []
            data.forEach(element => {
              var transferDate = element.transferDate // 日期
              var transferTime = element.transferTime // 时间
              var date = transferDate.substring(0, 4) + '-' + transferDate.substring(4, 6) + '-' + transferDate.substring(6, 8)
              var time = transferTime.substring(0, 2) + ':' + transferTime.substring(2, 4) + ':' + transferTime.substring(4, 6)
              params.push({
                BLID: this.yajincharge, // 计费受理单BLID
                serialNo: element.bankSeqNbr, // 企业流水号
                accountNo: element.oppositeAccNo, // 账号
                accountName: element.oppositeAccName, // 户名
                currencyType: 'RMB', // 币种
                transferAmt: element.transferAmt, // 交易金额
                billNbr: element.billNbr, // 票据
                accountInCate: element.accountInCate, // 入账业务类型
                balance: element.balance, // 账户余额
                purpose: element.purpose, // 摘要
                remark: 'w' + element.remark, // 备注
                ifCash: element.ifCash, // 现金标识
                ecTran: element.ecTran, // 冲正标识
                orderFlowNo: element.orderFlowNo, // 核心流水号
                transferDateTime: date + ' ' + time
              })
            })
            // 将选择的转账记录插入到bsn表中
            request({
              url: '/TChargeblbsn',
              method: 'POST',
              data: params
            }).then((apiresult:any) => {
              if (apiresult.code === 200) {
                // 模拟缴费成功后将计费受理单结算状态修改为已结算(如果为押金并且修改主表支付类型)
                request({
                  url: '/TChargebl/UpdateStlStatus?BLID=' + respone.data + '&&StlStatus=2&&StlType=3',
                  method: 'PUT'
                }).then((res:any) => {
                  if (res.code === 200) {
                    this.yajindisabled = true // 开启禁用状态
                    this.$message({
                      type: 'success',
                      message: '操作成功'
                    })
                    // 含有默认账户
                    if (this.isHaveDefault) {
                      // 维护退押信息并打印押金条
                      request({
                        url: '/TDptCntrBL/UpdateRetirement?BLID=' + this.selectbldata[0].blid + '&&AccountName=' + encodeURI(this.corpbankList[0].accountName) + '&&BankName=' + encodeURI(this.corpbankList[0].bankName) + '&&BankNo=' + this.corpbankList[0].bankNo,
                        method: 'PUT'
                      }).then((res:any) => {
                        if (res.code === 200) {
                          this.yajinLoading = false // 关闭支付按钮加载状态
                          this.depositdisabled = false // 关闭下一步禁用状态
                        } else {
                          this.$message({
                            type: 'warning',
                            message: res.message
                          })
                        }
                      }).catch((response:any) => {
                        console.log('失败')
                      })
                    } else { // 原路退回
                      let bankinfo = {
                        bankName: '',
                        bankNo: '',
                        accountName: ''
                      }
                      this.corpbankList.forEach(element => {
                        if (element.bankNo === params[0].accountNo) {
                          bankinfo.bankName = element.bankName
                          bankinfo.bankNo = element.bankNo
                          bankinfo.accountName = element.accountName
                        }
                      })
                      // 维护退押信息并打印押金条
                      request({
                        url: '/TDptCntrBL/UpdateRetirement?BLID=' + this.selectbldata[0].blid + '&&AccountName=' + encodeURI(bankinfo.accountName) + '&&BankName=' + encodeURI(bankinfo.bankName) + '&&BankNo=' + bankinfo.bankNo,
                        method: 'PUT'
                      }).then((res:any) => {
                        if (res.code === 200) {
                          this.yajinLoading = false // 关闭支付按钮加载状态
                          this.depositdisabled = false // 关闭下一步禁用状态
                        } else {
                          this.$message({
                            type: 'warning',
                            message: res.message
                          })
                        }
                      }).catch((response:any) => {
                        console.log('失败')
                      })
                    }
                  }
                }).catch((response:any) => {
                  console.log('失败')
                })
              } else {
                this.$message({
                  type: 'warning',
                  message: apiresult.message
                })
              }
            }).catch((apiresult:any) => {
              console.log('失败')
              this.yajinLoading = false // 关闭加载
            })
          } else {
            this.$message({
              type: 'warning',
              message: respone.message
            })
          }
        }).catch((response:any) => {
          console.log('失败')
        })
      }
    } else if (this.ruleForm.stlType === '7') { // 个人网银
      request({
        url: '/TChargebl?TDptCntrBlid=' + this.BLID + '&&type=' + encodeURI('押金'),
        method: 'PUT'
      }).then((res:any) => {
        if (res.code === 200) {
          this.$message({
            message: '生成计费受理单成功',
            type: 'success'
          })
          this.yajinLoading = false // 关闭加载
          this.yajincharge = res.data
          this.url = PlatformConfig.baseOnlineUrl + '/#/online/ceshi/'
          this.url = this.url + this.yajincharge
          // $('#Pcyear').attr('src', this.url)
          window.open(this.url)
          this.paymentdialogVisible = true
        } else {
          this.$message({
            type: 'warning',
            message: res.message
          })
        }
      }).catch((res:any) => {
        console.log('失败')
        this.yajinLoading = false // 关闭加载
      })
    }
  }
  // 生成计费受理单并打印
  private jiaonaxiuxixiang() {
    this.jiaonayajinloading = true // 按钮加载状态
    if (this.ruleForm.stlType === '') {
      this.$message({
        type: 'warning',
        message: '请选择收费方式后操作'
      })
      this.jiaonayajinloading = false
      return false
    }
    if (this.ruleForm.stlType === '3') {
      if (this.remittanceData.length === 0 || this.remittanceDataSelect.length === 0) { // 数据为零提示请选择转账记录
        this.$message({
          type: 'warning',
          message: '请选择转账记录'
        })
        this.jiaonayajinloading = false // 关闭加载
      } else {
        var totalAmt:number = 0
        this.remittanceDataSelect.forEach(element => {
          totalAmt += parseFloat(element.transferAmt)
        })
        if (totalAmt.toFixed(2) !== this.xiuxixiangfeiamt.toFixed(2)) {
          this.$message({
            type: 'warning',
            message: '选择金额金额不匹配'
          })
          this.jiaonayajinloading = false // 关闭加载
          return false
        }
        // 全部通过后首先生成计费受理单
        request({
          url: '/TChargebl?TDptCntrBlid=' + this.BLID + '&&type=' + encodeURI('修洗箱费'),
          method: 'PUT'
        }).then((respone:any) => {
          if (respone.code === 200) {
            this.yajincharge = respone.data // 记录押金的计费受理单ID
            var data = this.remittanceDataSelect
            var params = []
            data.forEach(element => {
              var transferDate = element.transferDate // 日期
              var transferTime = element.transferTime // 时间
              var date = transferDate.substring(0, 4) + '-' + transferDate.substring(4, 6) + '-' + transferDate.substring(6, 8)
              var time = transferTime.substring(0, 2) + ':' + transferTime.substring(2, 4) + ':' + transferTime.substring(4, 6)
              params.push({
                BLID: this.yajincharge, // 计费受理单BLID
                serialNo: element.bankSeqNbr, // 企业流水号
                accountNo: element.oppositeAccNo, // 账号
                accountName: element.oppositeAccName, // 户名
                currencyType: 'RMB', // 币种
                transferAmt: element.transferAmt, // 交易金额
                billNbr: element.billNbr, // 票据
                accountInCate: element.accountInCate, // 入账业务类型
                balance: element.balance, // 账户余额
                purpose: element.purpose, // 摘要
                remark: 'w' + element.remark, // 备注
                ifCash: element.ifCash, // 现金标识
                ecTran: element.ecTran, // 冲正标识
                orderFlowNo: element.orderFlowNo, // 核心流水号
                transferDateTime: date + ' ' + time
              })
            })
            // 将选择的转账记录插入到bsn表中
            request({
              url: '/TChargeblbsn',
              method: 'POST',
              data: params
            }).then((apiresult:any) => {
              if (apiresult.code === 200) {
                // 模拟缴费成功后将计费受理单结算状态修改为已结算
                request({
                  url: '/TChargebl/UpdateStlStatus?BLID=' + respone.data + '&&StlStatus=2&&StlType=3',
                  method: 'PUT'
                }).then((res:any) => {
                  if (res.code === 200) {
                    this.$message({
                      type: 'success',
                      message: '缴费成功'
                    })
                    this.shoukuandisabled = false
                    this.jiaonayajinloading = false
                    this.feedialogTableVisible = false
                    this.nowstltype = 3
                    this.getInvData()
                  }
                }).catch((response:any) => {
                  console.log('失败')
                })
              } else {
                this.$message({
                  type: 'warning',
                  message: apiresult.message
                })
              }
            }).catch((apiresult:any) => {
              console.log('失败')
              this.jiaonayajinloading = false // 关闭加载
            })
          } else {
            this.$message({
              type: 'warning',
              message: respone.message
            })
          }
        }).catch((response:any) => {
          console.log('失败')
        })
      }
    } else if (this.ruleForm.stlType === '7') {
      request({
        url: '/TChargebl?TDptCntrBlid=' + this.BLID + '&&type=' + encodeURI('修洗箱费'),
        method: 'PUT'
      }).then((respone:any) => {
        if (respone.code === 200) {
          this.$message({
            message: '生成计费受理单成功',
            type: 'success'
          })
          this.yajincharge = respone.data // 记录押金的计费受理单ID
          this.url = PlatformConfig.baseOnlineUrl + '/#/online/ceshi/'
          this.url = this.url + this.yajincharge
          // $('#Pcyear').attr('src', this.url)
          window.open(this.url)
          this.paymentdialogVisible = true
        } else {
          this.$message({
            type: 'warning',
            message: respone.message
          })
        }
      }).catch((response:any) => {
        console.log('失败')
        this.yajinLoading = false // 关闭加载
      })
    }
  }
  // 添加银行信息
  private addbank(formName) {
    (this.$refs[formName] as Form).validate((valid) => {
      if (valid) {
        this.addtuiyaform.bankID = ''
        this.addtuiyaform.corpID = this.ruleForm.corpID
        request({
          url: '/TCodecorpbank',
          method: 'POST',
          data: this.addtuiyaform
        }).then((respone:any) => {
          if (respone.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.addtuiyaform.accountName = '' // 清空开户公司名称
            this.addtuiyaform.bankName = '' // 清空开户行名称
            this.addtuiyaform.bankNo = '' // 清空退押账户开户行账号
            this.AddBankdialogVisible = false // 关闭添加对话框
            // 根据选择的客户获取对应的银行信息
            request({
              url: '/TCodecorpbank/GetTCodecorpbankDetailsByCorpID?Id=' + this.ruleForm.corpID
            }).then((respone:any) => {
              this.corpbankList = [] // 清空历史数据
              var corpbankList = respone.data // 首先拿到全部数据
              corpbankList.forEach(element => {
                if (element.isDefault === true) {
                  this.corpbankList.push(element)
                }
              })
              if (this.corpbankList.length === 0) {
                this.corpbankList = respone.data // 重新刷新下拉列表，确保获取最新数据
              }
            }).catch((response:any) => {
              console.log('失败')
            })
          } else {
            this.$message.error(respone.message)
          }
        }).catch((response:any) => {
          console.log('失败')
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }
  // 收押金下一步按钮
  private deposit() {
    // 获取押金支付状态是否异常
    request({
      url: '/TDptCntrBL/GetYJType?BLID=' + this.selectbldata[0].blid,
      method: 'GET'
    }).then((YJ:any) => {
      if (YJ.code === 200) {
        // 生成操作费并跳转下一页
        request({
          url: '/TCntrBL/GetCntrByDptBLID?BLID=' + this.BLID,
          method: 'GET'
        }).then((respone:any) => {
          if (respone.code === 200) {
            request({
              url: '/TCodecntrtype/GetCntrList',
              method: 'GET'
            }).then((res:any) => {
              var cntrtype = res.data
              // 拼接集装箱信息，还需要箱型对应的价格，去箱型表对比
              var cntrList:any = []
              var totalprice = 0
              for (var i = 0; i < respone.data.length; i++) {
                for (var k = 0; k < cntrtype.length; k++) {
                  var type = respone.data[i].cntrSize + respone.data[i].cntrType
                  if (type === cntrtype[k].cntrNo && respone.data[i].isSOC !== true) {
                    cntrList.push({ cntrType: cntrtype[k].cntrNo, cntrNo: respone.data[i].cntrNo, price: cntrtype[k].czfPrice.toFixed(2), mblNo: respone.data[i].mblNo })
                    totalprice += cntrtype[k].czfPrice
                  }
                }
              }
              cntrList.push({ cntrNo: '合计', cntrType: cntrList.length, price: totalprice.toFixed(2) })
              this.priceList = cntrList
              this.totalprice = totalprice
              this.danpiaoactiveName = 'fourth'
              this.stepactive = 2
              if (this.ruleForm.stlType === '3') {
                this.queryBankDetailed(new Date().setDate(new Date().getDate() - 30), new Date(), this.totalprice)
              }
            }).catch((response:any) => {
              console.log('失败')
            })
          } else {
            this.$message.error(respone.message)
          }
        }).catch((response:any) => {
          console.log('失败')
        })
      } else {
        this.$message({
          type: 'warning',
          message: YJ.message
        })
      }
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  // 操作费
  private jiaonacaozuofei() {
    this.jiaonacaozuofeiloading = true
    this.jiaonacaozuofeidisabled = true
    var _self = this
    // 获取押金支付状态是否异常
    request({
      url: '/TDptCntrBL/GetYJType?BLID=' + this.selectbldata[0].blid,
      method: 'GET'
    }).then((YJ:any) => {
      if (YJ.code === 200) {
        if (this.ruleForm.stlType === '3') { // 收费方式为汇款情况
          if (this.remittanceData.length === 0 || this.remittanceDataSelect.length === 0) { // 数据为零提示请选择转账记录
            this.$message({
              type: 'warning',
              message: '请选择转账记录'
            })
            this.jiaonacaozuofeiloading = false // 关闭加载
            this.jiaonacaozuofeidisabled = false
          } else {
            var totalAmt:number = 0
            this.remittanceDataSelect.forEach(element => {
              totalAmt += parseFloat(element.transferAmt)
            })
            if (totalAmt !== parseFloat(this.totalprice)) {
              this.$message({
                type: 'warning',
                message: '选择金额金额不匹配'
              })
              this.jiaonacaozuofeiloading = false // 关闭加载
              this.jiaonacaozuofeidisabled = false
              return false
            }
            // 全部通过后首先生成计费受理单
            request({
              url: '/TChargebl?TDptCntrBlid=' + this.selectbldata[0].blid + '&&type=' + encodeURI('操作费'),
              method: 'PUT'
            }).then((respone:any) => {
              if (respone.code === 200) {
                this.yajincharge = respone.data // 记录押金的计费受理单ID
                var data = this.remittanceDataSelect
                var params = []
                data.forEach(element => {
                  var transferDate = element.transferDate // 日期
                  var transferTime = element.transferTime // 时间
                  var date = transferDate.substring(0, 4) + '-' + transferDate.substring(4, 6) + '-' + transferDate.substring(6, 8)
                  var time = transferTime.substring(0, 2) + ':' + transferTime.substring(2, 4) + ':' + transferTime.substring(4, 6)
                  params.push({
                    BLID: this.yajincharge, // 计费受理单BLID
                    serialNo: element.bankSeqNbr, // 企业流水号
                    accountNo: element.oppositeAccNo, // 账号
                    accountName: element.oppositeAccName, // 户名
                    currencyType: 'RMB', // 币种
                    transferAmt: element.transferAmt, // 交易金额
                    billNbr: element.billNbr, // 票据
                    accountInCate: element.accountInCate, // 入账业务类型
                    balance: element.balance, // 账户余额
                    purpose: element.purpose, // 摘要
                    remark: 'w' + element.remark, // 备注
                    ifCash: element.ifCash, // 现金标识
                    ecTran: element.ecTran, // 冲正标识
                    orderFlowNo: element.orderFlowNo, // 核心流水号
                    transferDateTime: date + ' ' + time
                  })
                })
                // 将选择的转账记录插入到bsn表中
                request({
                  url: '/TChargeblbsn',
                  method: 'POST',
                  data: params
                }).then((apiresult:any) => {
                  if (apiresult.code === 200) {
                    // 模拟缴费成功后将计费受理单结算状态修改为已结算
                    request({
                      url: '/TChargebl/UpdateStlStatus?BLID=' + respone.data + '&&StlStatus=2&&StlType=3',
                      method: 'PUT'
                    }).then((res:any) => {
                      if (res.code === 200) {
                        // 修改单据状态
                        request({
                          url: '/TDptCntrBL/UpdateDptCntrBLStatus?BLID=' + this.selectbldata[0].blid + '&&Status=4',
                          method: 'PUT'
                        }).then((res:any) => {
                          if (res.code === 200) {
                            this.jiaonacaozuofeiloading = false
                            this.nowstltype = 3
                            this.getInvData()
                          }
                        }).catch((res:any) => {
                          console.log('失败')
                        })
                      }
                    }).catch((response:any) => {
                      console.log('失败')
                    })
                  } else {
                    this.$message({
                      type: 'warning',
                      message: apiresult.message
                    })
                  }
                }).catch((apiresult:any) => {
                  console.log('失败')
                  this.yajinLoading = false // 关闭加载
                })
              } else {
                this.$message({
                  type: 'warning',
                  message: respone.message
                })
              }
            }).catch((response:any) => {
              console.log('失败')
            })
          }
        } else if (this.ruleForm.stlType === '7') {
          request({
            url: '/TChargebl?TDptCntrBlid=' + this.selectbldata[0].blid + '&&type=' + encodeURI('操作费'),
            method: 'PUT'
          }).then((respone:any) => {
            if (respone.code === 200) {
              this.$message({
                message: '生成计费受理单成功',
                type: 'success'
              })
              this.yajincharge = respone.data // 记录押金的计费受理单ID
              this.url = PlatformConfig.baseOnlineUrl + '/#/online/ceshi/'
              this.url = this.url + this.yajincharge
              // $('#Pcyear').attr('src', this.url)
              window.open(this.url)
              this.paymentdialogVisible = true
            } else {
              this.$message({
                type: 'warning',
                message: respone.message
              })
              this.yajinLoading = false // 关闭加载
            }
            this.yajinLoading = false // 关闭加载
          }).catch((response:any) => {
            console.log('失败')
            this.yajinLoading = false // 关闭加载
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请选择付款方式'
          })
          this.jiaonacaozuofeiloading = false
          this.jiaonacaozuofeidisabled = false
        }
      } else {
        this.$message({
          type: 'warning',
          message: YJ.message
        })
      }
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  // 提交开票
  private submitInv() {
    if (this.selectbldata.length > 1) {
      this.$message({
        message: '每次最多操作一个',
        type: 'warning'
      })
    } else if (this.selectbldata.length < 1) {
      this.$message({
        message: '请勾选数据后操作',
        type: 'warning'
      })
    } else if (this.selectbldata[0].jfType === '押金') {
      this.$message({
        message: '押金不可开票',
        type: 'warning'
      })
    } else if (this.selectbldata[0].stlStatus === 1) {
      this.$message({
        message: '请结算后操作',
        type: 'warning'
      })
    } else {
      if (this.selectbldata[0].stlType === 3) {
        // 获取转账记录
        request({
          url: '/TChargeblbsn/GetBSNByChargeID?BLID=' + this.selectbl[0].blid,
          method: 'GET'
        }).then((respone:any) => {
          console.log(respone)
          if (respone.code === 200) {
            if (respone.data.accountName.indexOf('公司') >= 0) {
              request({
                url: '/TCodecorpinv/GetListByTokenCorp?pi=' + this.invlistQuery.pi + '&&ps=' + this.invlistQuery.ps + '&&CorpName=' + respone.data.accountName,
                method: 'GET'
              }).then((respone:any) => {
                this.invData = respone.list
                this.invtotal = respone.total
              }).catch((response:any) => {
                console.log('失败')
              })
              this.InvDialog = true
            } else {
              request({
                url: '/TCodecorpinv/GetListByTokenCorp?pi=' + this.invlistQuery.pi + '&&ps=' + this.invlistQuery.ps,
                method: 'GET'
              }).then((respone:any) => {
                this.invData = respone.list
                this.invtotal = respone.total
              }).catch((response:any) => {
                console.log('失败')
              })
              this.InvDialog = true
            }
          } else {
            this.$message({
              type: 'warning',
              message: '提交发票异常'
            })
          }
        }).catch((response:any) => {
          console.log('失败')
        })
      } else {
        request({
          url: '/TCodecorpinv/GetListByTokenCorp?pi=' + this.invlistQuery.pi + '&&ps=' + this.invlistQuery.ps,
          method: 'GET'
        }).then((respone:any) => {
          this.invData = respone.list
          this.invtotal = respone.total
        }).catch((response:any) => {
          console.log('失败')
        })
        this.invloading = false
        this.InvDialog = true
      }
    }
  }
  // 提交开票
  private Inv() {
    if (this.InvSelectBL.length > 1) {
      this.$message({
        message: '每次最多操作一个',
        type: 'warning'
      })
    } else if (this.InvSelectBL.length < 1) {
      this.$message({
        message: '请勾选数据后操作',
        type: 'warning'
      })
    } else if (this.selectbldata[0].stlStatus === 1) {
      this.$message({
        message: '请结算后操作',
        type: 'warning'
      })
    } else if (this.posttype === 0) {
      this.$message({
        message: '请选择领取方式后操作',
        type: 'warning'
      })
    } else if (this.invtype === 0) {
      this.$message({
        message: '请选择发票类型后操作',
        type: 'warning'
      })
    } else if (this.posttype === 1 && (this.addrID === '' || this.expressTel === '' || this.expressAttn === '')) {
      this.$message({
        message: '请完善邮寄信息后操作',
        type: 'warning'
      })
    } else {
      this.invloading = true
      var inv = this.InvSelectBL[0] // InvSelectBL抬头信息
      request({
        url: '/TChargebl/GetDetails?BLID=' + this.yajincharge,
        method: 'GET'
      }).then((result:any) => {
        var charge = result.data // charge信息
        request({
          url: '/TChargeblfee/GetChargeblFeeDetails?BLID=' + this.yajincharge,
          method: 'GET'
        }).then((respone:any) => {
          var chargefee = respone.data
          var invAmt = 0
          var intItem = []
          var feeName = '' // 费用名
          var taxRateDr:any = 0 // 税率
          for (var i = 0; i < chargefee.length; i++) {
            invAmt += parseFloat(chargefee[i].amt)
            $.ajax({
              url: PlatformConfig.baseServerUrlApi + '/TCodefee/GetTCodefeeDetailsAsync?Id=' + chargefee[i].feeID, // url路径
              type: 'GET', // GET
              async: false, // 或false,是否异步
              timeout: 5000, // 超时时间
              success: function(data:any) {
                feeName = data.data.feeCN
                taxRateDr = data.data.taxRateDr
              },
              error: function(xhr:any) {
                console.log(xhr)
              }
            })
            var TaxAmt:any = 0 // 税额
            TaxAmt = ((chargefee[i].amt / (1 + taxRateDr)) * taxRateDr).toFixed(2)
            var netAmt:any = 0 // 净额
            netAmt = chargefee[i].amt - TaxAmt
            intItem.push({
              FeeID: chargefee[i].feeID,
              MBLNo: chargefee[i].mblNo,
              Amt: chargefee[i].amt,
              ChargeBLNo: chargefee[i].blno,
              CntrNo: chargefee[i].cntrNo,
              FcyNo: 'RMB',
              MergeFee: feeName,
              TaxRate: taxRateDr,
              TaxAmt: TaxAmt,
              NetAmt: netAmt,
              SrcBLFeeID: chargefee[i].blFeeID
            })
          }
          var remark = '网银'
          var _self = this
          $.ajax({
            url: PlatformConfig.baseServerUrlApi + '/TChargebl/GetDetails?BLID=' + this.yajincharge, // url路径
            headers: {
              Authorization: 'Bearer ' + UserModule.token
            },
            type: 'GET', // GET
            async: false, // 或false,是否异步
            timeout: 5000, // 超时时间
            success: function(data:any) {
              if (respone.code === 200) {
                switch (respone.data.stlType) {
                  case 1:
                    remark = charge.mblNo + '+支票'
                    break
                  case 2:
                    remark = charge.mblNo + '+POS'
                    break
                  case 3:
                    remark = charge.mblNo + '+汇款'
                    break
                  case 4:
                    remark = charge.mblNo + '+转押'
                    break
                  case 5:
                    remark = charge.mblNo + '+协议'
                    break
                  case 6:
                    remark = charge.mblNo + '+现金'
                    break
                  case 7:
                    remark = charge.mblNo + '+网银'
                    break
                }
              } else {
                _self.$message.error(respone.message)
              }
            },
            error: function(xhr:any) {
              console.log(xhr)
            }
          })
          var ExpressAttn = null
          var ExpressAddr = null
          var ExpressTel = null
          if (this.posttype === 1) {
            ExpressAttn = this.expressAttn
            ExpressAddr = this.expressAddr
            ExpressTel = this.expressTel
          }
          var invform = {
            BLNo: '', // 业务编号
            BLDate: this.GetDateNow, // 发票日期 当天
            UserID: this.userinfo.id, // 用户ID
            UserName: this.userinfo.realName, // 开票人
            OnLine: true, // 在线
            FcyNo: 'RMB', // 发票币种
            InvStatus: 1, // 开票状态 未开票
            CorpCName: inv.corpName, // 客户名称
            CorpTaxNo: inv.taxCode, // 纳税人识别号
            CorpInvAddr: inv.addressPhone, // 客户地址
            CorpInvBank: inv.bankAccount, // 银行
            InvType: this.invtype, // 发票类型
            // TaxRate: '', // 税率
            InvHead: this.InvSelectBL[0].corpName,
            InvAmt: invAmt, // 发票金额
            CorpID: charge.corpID, // 结算单位
            Con_BLNo: charge.dptBLNo, // 押箱单号
            Con_MBLNo: charge.mblNo, // 提单号
            Con_ChargeBLNo: charge.blNo, // 计费单号
            Con_Fees: chargefee[0].feeID, // 费用
            SaleCName: '青岛东港国际集装箱储运有限公司', // 名称
            saleTaxNo: '9137020061432494X3', // 纳税人编号
            saleInvAddr: '山东省青岛市保税港区上海路34号一段三层A区7-1（B）0532-82987025', // 地址电话
            saleInvBank: '交通银行青岛崇明岛路支行 372600600018000424889', // 开户行及卡号
            remark: charge.mblNo + '+' + remark, // 备注
            SrcBLID: this.yajincharge, // 计费受理单ID
            casher: '殷东', // 收款人
            reCheck: '徐超', // 复核人
            posttype: this.posttype,
            ExpressAttn: ExpressAttn,
            ExpressAddr: ExpressAddr,
            ExpressTel: ExpressTel,
            EditTInvblItemDto: intItem
          }
          request({
            url: '/TInvbl',
            method: 'POST',
            data: invform
          }).then((respone:any) => {
            if (respone.code === 200) {
              this.$message({
                message: '开票成功',
                type: 'success'
              })
              this.invloading = false
              this.InvDialog = false
              this.invtype = 0
              if (charge.jfType === '修洗箱费') {
                request({
                  url: '/TDptCntrBL/UpdateDptCntrBLStatus?BLID=' + this.selectbldata[0].blid + '&&Status=5',
                  method: 'PUT'
                }).then((respone:any) => {
                  if (respone.code === 200) {
                    // this.$message({
                    //   type: 'success',
                    //   message: '缴费成功'
                    // })
                  }
                }).catch((response:any) => {
                  console.log('失败')
                })
              }
            } else {
              this.$message.error(respone.message)
            }
          }).catch((response:any) => {
            console.log('失败')
          })
        }).catch((response:any) => {
          console.log('失败')
        })
      }).catch((result:any) => {
        console.log('失败')
      })
    }
  }
  private retirementdisabled = false // 退押按钮禁用
  private retirementloading = false // 退押按钮加载
  private yuanyin = []
  private cntrBlFeeList = []
  private remittanceAmt = 0
  // 退押按钮 显示费用列表
  private retirement() {
    let _this = this
    if (this.selectbldata.length === 0) {
      this.$message({
        type: 'warning',
        message: '请选择数据后操作'
      })
      return false
    }
    this.retirementdisabled = true // 退押按钮禁用开启
    this.retirementloading = true // 退押加载开启
    let BLID = this.selectbldata[0].blid
    this.BLID = this.selectbldata[0].blid

    if (this.selectbldata[0].stlType === 3 || this.selectbldata[0].stlType === 7) { // 汇款方式
      // 判断默认账户限制，是否可以退款
      request({
        url: '/TDptCntrBL/isRetirement?BLID=' + BLID + '&&corpID=' + this.selectbldata[0].corpID,
        method: 'GET'
      }).then((respone:any) => {
        if (respone.code === 200) {
          // 获取最新提单信息
          request({
            url: '/TDptCntrBL/GetModel?Id=' + BLID,
            method: 'GET'
          }).then((result:any) => {
            if (result.code === 200) {
              request({
                url: '/TCntrBL/UpdateSlimCntr?Mblnos=' + result.data.mblNo,
                method: 'GET'
              }).then((resp:any) => {
                if (resp.code === 200) {
                  this.yuanyin = []
                  if (resp.data.sign === false) { // 存在不允许退款情况
                    if (resp.data.isEmptyReturn === false) {
                      this.yuanyin.push('集装箱未空箱返场')
                    }
                    if (resp.data.isCarrierAllow === false) {
                      this.yuanyin.push('船公司未审核，不能退押')
                    }
                    if (resp.data.isLocked === false) {
                      this.yuanyin.push('集装箱已锁箱')
                    }
                    if (resp.data.isDaiding === false) {
                      this.yuanyin.push('集装箱存在待定费用')
                    }
                    this.retirementdisabled = false // 退押按钮禁用关闭
                    this.retirementloading = false // 退押加载关闭
                    this.dialogyuanyinVisible = true
                  } else { // 允许退款后判断是否存在未结算费用
                    this.retirementdisabled = false // 退押按钮禁用关闭
                    this.retirementloading = false // 退押加载关闭
                    this.cntrBlFeeList = []

                    // 首先获取最新的状态判断是否退押
                    if (result.data.dptStatus === 5 || result.data.dptStatus === 6) {
                      this.$message({
                        type: 'warning',
                        message: '该单据已退款'
                      })
                    } else {
                      request({
                        url: '/TDptCntrBL/GetCntrBlFeeList?BLID=' + BLID,
                        method: 'GET'
                      }).then((respone:any) => {
                        this.cntrBlFeeList = respone.list
                        var total = 0
                        respone.list.forEach(item => {
                          total += item.amt
                          item.price = item.amt
                        })
                        this.remittanceAmt = total
                        if (this.cntrBlFeeList.length > 0) {
                          this.cntrBlFeeList.push({ cntrNo: '合计', price: total.toFixed(2) })
                          // this.ruleForm.amt = total
                          this.xiuxixiangfeiamt = total
                        }
                        if (this.cntrBlFeeList.length > 0) {
                          request({
                            url: '/TDptCntrBL/GetFirstMBLNoByBLID?BLID=' + BLID
                          }).then((respone:any) => {
                            if (respone.code === 200) {
                              this.mblno = respone.data
                            }
                          }).catch((res:any) => {
                            console.log('失败')
                          })
                          request({
                            url: '/TChargebl/GetStlstatus?BLID=' + BLID,
                            method: 'GET'
                          }).then((res:any) => {
                            if (res.code === 200) { // 含有计费受理单并结算
                            // 已结算后需提交开票修改状态
                              this.$message({
                                type: 'warning',
                                message: res.message
                              })
                            } else if (res.code === 201) {
                              this.feedialogTableVisible = true
                            } else if (res.code === 203) {
                              this.feedialogTableVisible = true
                            }
                          }).catch((res:any) => {
                            console.log('失败')
                          })
                        } else {
                          request({
                            url: '/TDptCntrBL/UpdateDptCntrBLStatus?BLID=' + BLID + '&&Status=5',
                            method: 'PUT'
                          }).then((res:any) => {
                            if (res.code === 200) {
                              this.$message({
                                type: 'success',
                                message: '操作成功'
                              })
                              this.getList()
                            }
                          }).catch((res:any) => {
                            console.log('失败')
                          })
                        }
                      }).catch((response:any) => {
                        console.log('失败')
                      })
                    }
                  }
                }
              }).catch((resp:any) => {
                console.log('失败')
              })
            } else {
              this.$message({
                type: 'warning',
                message: result.message
              })
            }
          }).catch((result:any) => {
            console.log('失败')
          })
        } else {
          this.$message({
            type: 'warning',
            message: respone.message
          })
        }
      }).catch((respone:any) => {
        console.log('失败')
      })
    } else {
      request({
        url: '/TDptCntrBL/GetModel?Id=' + BLID,
        method: 'GET'
      }).then((result:any) => {
        if (result.code === 200) {
          request({
            url: '/TCntrBL/UpdateSlimCntr?Mblnos=' + result.data.mblNo,
            method: 'GET'
          }).then((resp:any) => {
            if (resp.code === 200) {
              this.yuanyin = []
              if (resp.data.sign === false) { // 存在不允许退款情况
                if (resp.data.isEmptyReturn === false) {
                  this.yuanyin.push('集装箱未空箱返场')
                }
                if (resp.data.isCarrierAllow === false) {
                  this.yuanyin.push('船公司未审核，不能退押')
                }
                if (resp.data.isLocked === false) {
                  this.yuanyin.push('集装箱已锁箱')
                }
                if (resp.data.isDaiding === false) {
                  this.yuanyin.push('集装箱存在待定费用')
                }
                this.retirementdisabled = false // 退押按钮禁用关闭
                this.retirementloading = false // 退押加载关闭
                this.dialogyuanyinVisible = true
              } else { // 允许退款后判断是否存在未结算费用
                this.retirementdisabled = false // 退押按钮禁用关闭
                this.retirementloading = false // 退押加载关闭
                this.cntrBlFeeList = []

                // 首先获取最新的状态判断是否退押
                if (result.data.dptStatus === 5 || result.data.dptStatus === 6) {
                  this.$message({
                    type: 'warning',
                    message: '该单据已退款'
                  })
                } else {
                  request({
                    url: '/TDptCntrBL/GetCntrBlFeeList?BLID=' + BLID,
                    method: 'GET'
                  }).then((respone:any) => {
                    this.cntrBlFeeList = respone.list
                    var total = 0
                    respone.list.forEach(item => {
                      total += item.amt
                      item.price = item.amt
                    })
                    this.remittanceAmt = total
                    if (this.cntrBlFeeList.length > 0) {
                      this.cntrBlFeeList.push({ cntrNo: '合计', price: total.toFixed(2) })
                      // this.ruleForm.amt = total
                      this.xiuxixiangfeiamt = total
                    }
                    if (this.cntrBlFeeList.length > 0) {
                      request({
                        url: '/TDptCntrBL/GetFirstMBLNoByBLID?BLID=' + BLID
                      }).then((respone:any) => {
                        if (respone.code === 200) {
                          this.mblno = respone.data
                        }
                      }).catch((res:any) => {
                        console.log('失败')
                      })
                      request({
                        url: '/TChargebl/GetStlstatus?BLID=' + BLID,
                        method: 'GET'
                      }).then((res:any) => {
                        if (res.code === 200) { // 含有计费受理单并结算
                        // 已结算后需提交开票修改状态
                          this.$message({
                            type: 'warning',
                            message: res.message
                          })
                        } else if (res.code === 201) {
                          this.feedialogTableVisible = true
                        } else if (res.code === 203) {
                          this.feedialogTableVisible = true
                        }
                      }).catch((res:any) => {
                        console.log('失败')
                      })
                    } else {
                      request({
                        url: '/TDptCntrBL/UpdateDptCntrBLStatus?BLID=' + BLID + '&&Status=5',
                        method: 'PUT'
                      }).then((res:any) => {
                        if (res.code === 200) {
                          this.$message({
                            type: 'success',
                            message: '操作成功'
                          })
                          this.getList()
                        }
                      }).catch((res:any) => {
                        console.log('失败')
                      })
                    }
                  }).catch((response:any) => {
                    console.log('失败')
                  })
                }
              }
            }
          }).catch((resp:any) => {
            console.log('失败')
          })
        } else {
          this.$message({
            type: 'warning',
            message: result.message
          })
        }
      }).catch((result:any) => {
        console.log('失败')
      })
    }
  }
  get GetDateNow() {
    var date = new Date()
    var seperator1 = '-'
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var strDate = date.getDate()
    var Y = ''
    var M = ''
    var D = ''
    if (month >= 1 && month <= 9) {
      M = '0' + month
    } else {
      M = month.toString()
    }
    if (strDate >= 0 && strDate <= 9) {
      D = '0' + strDate
    } else {
      D = strDate.toString()
    }
    var currentdate = year + seperator1 + M + seperator1 + D
    return currentdate
  }
  // 完成操作清空所有数据
  private success() {
    request({
      url: '/TChargebl/GetChargeStlStatus?BLNo=' + this.BLNo + '&&JFType=' + encodeURI('操作费'),
      method: 'GET'
    }).then((res:any) => {
      if (res.message !== '未产生计费受理单，请产生计费受理单后继续操作') {
        // 第一步关闭对话框
        this.dialogTableVisible = false // 关闭单票查询对话框
        this.getList()
        // 第二步调整选项卡
        this.danpiaoactiveName = 'first' // 将单票查询对话框选项卡调至第一个
        // 第三步清空所有数据
        // 单票查询表单重置
        this.ticketMblno = ''
        this.form.mblNo = ''
        this.form.vesselCode = ''
        this.form.impVoy = ''
        this.form.carrierCode = ''
        this.form.boxSum = ''
        this.form.releaseState = ''
        // 清空箱子信息
        this.leveltableData = []
        // 清空选中提单信息
        this.selecttableData = []
        // 录入押箱信息表单重置
        this.ruleForm.amt = ''
        this.priceList = [] // 操作费的表格
        this.stepactive = 0 // 将进度条重置至第一个
        this.jiaonacaozuofeidisabled = false // 关闭缴纳操作费禁用
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    }).catch((res:any) => {
      console.log('失败')
    })
  }
  // 打印押金条
  private printdeposit() {
    this.yajinLoading = false // 关闭加载
    this.yajindisabled = true // 开启禁用状态
    this.depositdisabled = false // 关闭禁用状态
    var title = document.title // 获取页面title信息
    var divElements = (document.getElementById('container') as any).innerHTML // 获取需打印内容
    var printWindow:any = window.open('about:blank') // 打开新页面

    setTimeout(function name() { // 待页面加载完成后打印
      if (printWindow === undefined || printWindow === null) {
        this.$message({
          type: 'warning',
          message: '打印押金条失败'
        })
        return false
      }
      // printWindow.document.open() // 开启新页面
      printWindow.document.write('<html><head><title>' + title + '</title>') // 开始编写页面内容
      printWindow.document.write('<style> .title{ margin-top: 25px;width: 100%;height: 50px;text-align:center }') // 添加所需css
      printWindow.document.write('html { line-height: 1.15;-webkit-text-size-adjust: 100%; }')

      printWindow.document.write('.el-row { position: relative;-webkit-box-sizing: border-box;box-sizing: border-box; }')
      printWindow.document.write('.el-col-3 { width: 12.5%; }')
      printWindow.document.write('.el-col-4 { width: 16.6666666667%; }')
      printWindow.document.write('.el-col-5 { width: 20.8333333333% }')
      printWindow.document.write('.el-col-6 { width: 25% }')
      printWindow.document.write('.el-col-8 { width: 33.3333333333%; }')
      printWindow.document.write('.el-col-10 { width: 41.6666666667% }')
      printWindow.document.write('.el-col-12 { width: 50%; }')
      printWindow.document.write('.el-col-21 {  width: 87.5%; }')
      printWindow.document.write('[class*=el-col-] {float: left;-webkit-box-sizing: border-box;box-sizing: border-box; }')

      printWindow.document.write('.printarea { width: 21cm;height: 13cm;padding :0; }')
      printWindow.document.write('.JF{ position: relative;left: -150px;top: -47px;font-weight: bold }')
      printWindow.document.write('.bordertop{ width: 95%;height: 28px;line-height:28px;border: 1px solid #000; }')
      printWindow.document.write('.bordermain{ width: 95%;height: 28px;line-height:28px;border: 1px solid #000;border-top:none }')
      printWindow.document.write('.borderright{ border-right:1px solid #000;height:100%;}')
      // printWindow.document.write('.bold{ font-weight: bold}')
      printWindow.document.write('.main{ width: 100%;height: 190px;font-size: 14px; }')
      printWindow.document.write('</style></head><body>')
      printWindow.document.write(divElements) // 添加页面内容
      printWindow.document.write('</body></html>')
      printWindow.document.close()
      printWindow.focus()
      setTimeout(function name() { // 待页面加载完成后打印
        printWindow.print()
      }, 200)
    }, 300)
  }
  private NoDepositRequiredCarrier:any = []
  // 初始化
  created() {
    this.getList() // 获取押箱列表
    this.GetTokenUserDetailsAsync() // 获取登录用户信息
    // this.setCookie(1) // 设置cookie，查询放行状态 类型1不查询
    this.getCorpSelectList()
    this.getaddrselectlist()
    this.GetSetting()
  }
  private GetSetting() {
    this.listLoading = true
    request({
      url: '/SysUser/GetSetting',
      method: 'GET',
      params: {
        SettingCode: 'NoCheckCodeCarrier'
      }
    }).then((respone:any) => {
      this.NoDepositRequiredCarrier = respone.settingValue.split(',')
      console.log(this.NoDepositRequiredCarrier)
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  // 获取列表
  private async getList() {
    this.listLoading = true
    this.tableData = []
    request({
      url: '/TDptCntrBL',
      method: 'GET',
      params: this.listQuery
    }).then((respone:any) => {
      this.tableData = respone.list
      this.total = respone.total
      this.listLoading = false
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  // 获取登录人信息
  private async GetTokenUserDetailsAsync() {
    request({
      url: '/SysUser/GetTokenUserDetailsAsync',
      method: 'GET',
      params: this.listQuery
    }).then((respone:any) => {
      this.realName = respone.data.realName
      this.userinfo = respone.data
      request({
        url: '/TCodecorp/GetTCodecorpDetailsAsync?Id=' + this.userinfo.copId,
        method: 'GET'
      }).then((respone:any) => {
        this.form.isAgmt = respone.data.isAgmt // 是否中远协议
        this.form.isDGAgmt = respone.data.isDGAgmt // 是否东港协议
        this.form.agmtType = respone.data.agmtType // 协议类型
        this.form.corpname = respone.data.corpCN
        this.form.corpcode = respone.data.organizeNo
        this.ruleForm.corpname = respone.data.corpCN
        this.ruleForm.checkNo = respone.data.checkNo
        this.ruleForm.corpAttn = this.realName
        this.ruleForm.corpTEL = this.userinfo.tel
        console.log(this.form)
        request({
          url: '/TCodecorpbank/GetTCodecorpbankDetailsByCorpID?Id=' + this.userinfo.copId
        }).then((respone:any) => {
          this.banklist = respone.data
          this.corpbankList = [] // 清空历史数据
          var corpbankList = respone.data // 首先拿到全部数据
          corpbankList.forEach(element => {
            if (element.isDefault === true) {
              this.corpbankList.push(element)
            }
          })
          if (this.corpbankList.length === 0) {
            this.corpbankList = respone.data // 重新刷新下拉列表，确保获取最新数据
            this.isHaveDefault = false
          } else {
            this.isHaveDefault = true
          }
        }).catch((response:any) => {
          console.log('失败')
        })
      }).catch((response:any) => {
        console.log('失败')
      })
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  // 单票查询
  private async getTicketList() {
    request({
      url: '/TCntrBL',
      method: 'GET',
      params: { Mblno: this.ticketMblno }
    }).then((respone:any) => {
      if (respone.code === 200) {
        if (respone.data === null) {
          this.$message({
            message: '没有搜索到结果',
            type: 'warning'
          })
          this.searchdisabled = false // 提示后开启按钮
        } else {
          this.$message({
            message: '查询成功',
            type: 'success'
          })
          this.searchdisabled = false // 提示后开启按钮
          this.form.freeTimePeriod = '查询中'
          this.form.freeDueDate = '查询中'
          this.form.mblNo = respone.data.mblNo
          this.form.vesselCode = respone.data.vesselCode
          this.form.impVoy = respone.data.impVoy
          this.form.carrierCode = respone.data.carrierCode
          this.form.boxSum = respone.data.boxSum
          this.form.releaseState = respone.data.releaseState
          this.form.vesselEN = respone.data.data[0].vesselEN

          this.leveltableData = respone.data.data
          this.searchData = respone.data
          // var Params = []
          // var date = new Date()
          // var year = date.getFullYear()
          // var month = date.getMonth() + 1
          // var day = date.getDate()
          // var hour = date.getHours()
          // var minute = date.getMinutes()
          // var second = date.getSeconds()
          // var nowdatetime = year + '-' + this.conver(month) + '-' + this.conver(day) + ' ' + this.conver(hour) + ':' + this.conver(minute) + ':' + this.conver(second)
          // date.setMonth(date.getMonth() - 1) // 这里的1就是你要加的天数，减也可以。年、月会相应加上去，值得注意的是date.getMonth()得到的月份比实际月份小1
          // Params.push({
          //   billNo: respone.data.mblNo, // 提单号
          //   startTime: date.getFullYear() + '-' + this.conver(date.getMonth() + 1) + '-' + this.conver(date.getDate()) + ' ' + this.conver(hour) + ':' + this.conver(minute) + ':' + this.conver(second), // 更新时间开始时间, 精确到秒
          //   endTime: nowdatetime, // 更新时间结束时间, 精确到秒
          //   uploadTime: date.getFullYear() + '-' + this.conver(date.getMonth() + 1) + '-' + this.conver(date.getDate()) + ' ' + this.conver(hour) + ':' + this.conver(minute) + ':' + this.conver(second) // 上传时间
          // })
          // request({
          //   url: '/TChargebl/EirHoldBoxApply',
          //   method: 'POST',
          //   data: Params
          // }).then((res:any) => {
          //   if (res.code === 200) {
          //     console.log(res)
          //     if (res.data.success) {
          //       if (res.data.message.list.length === 0) {
          //         this.$message({
          //           type: 'warning',
          //           message: '拉取失败'
          //         })
          //       } else {
          //         this.form.freeTimePeriod = res.data.message.list[0].billInfo.freeTimePeriod
          //         this.form.freeDueDate = res.data.message.list[0].billInfo.freeDueDate
          //         if (this.form.freeTimePeriod !== '') {
          //           request({
          //             url: '/TCntrBL/UpdateCntrByMblno',
          //             method: 'GET',
          //             params: { MBLNo: this.form.mblNo, daycount: this.form.freeTimePeriod.substring(0, this.form.freeTimePeriod.length - 1), FreeExpire: this.form.freeDueDate }
          //           }).then((res:any) => {
          //             console.log(res)
          //           }).catch((response:any) => {
          //             console.log('失败')
          //           })
          //         }
          //       }
          //     } else {
          //       this.$message({
          //         type: 'warning',
          //         message: res.data.message.msg
          //       })
          //     }
          //   }
          // }).catch((response:any) => {
          //   console.log('失败')
          // })
        }
      } else {
        if (respone.message === '此提单号已押箱，不允许再次押箱') {
          this.$message({
            message: '此提单号已押箱，不允许再次押箱',
            type: 'warning'
          })
        } else if (respone.message === '当前用户已被停止押箱') {
          this.$message({
            message: '当前用户已被停止押箱',
            type: 'warning'
          })
        } else {
          this.$message({
            message: '没有搜索到结果',
            type: 'warning'
          })
        }
        this.searchdisabled = false // 提示后开启按钮
      }
    }).catch((response:any) => {
      console.log('失败')
      this.searchdisabled = false // 提示后开启按钮
    })
  }
  // 设置cookie，用于查询放行状态
  private setCookie(type:any) {
    var d = new Date()
    d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000))
    var expires = 'expires=' + d.toUTCString()
    request({
      url: '/TCntrBL/QueryReleaseLogin',
      method: 'GET',
      params: { username: '18754218061', password: 'YongSi123' }
    }).then((respone:any) => {
      if (respone.code === 200) {
        // console.info('YGT' + '=' + respone.data + '; ' + expires)
        document.cookie = 'YGT' + '=' + respone.data + '; ' + expires
        if (type === 2) {
          this.getCookie(this.form.mblNo)
        }
        // console.info(document.cookie)
      }
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  // 获取cookie
  private getCookie(mblNo:any) {
    var _self = this
    var name = 'YGT' + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1)
      if (c.indexOf(name) !== -1) {
        if (c.substring(name.length, c.length) !== undefined) { // 查询到cookie
          request({
            url: '/TCntrBL/QueryRelease',
            method: 'GET',
            params: { cookie: c.substring(name.length, c.length), blno: mblNo }
          }).then((respone:any) => {
            if (respone.code === 200 && respone.message === '获取成功') {
              if (respone.data === []) {
                console.log('未查询到相关信息')
              } else {
                if (respone.data[0].warehousE_CODE === 'A') {
                  this.form.releaseState = '已放行'
                } else {
                  this.form.releaseState = '未放行'
                }
              }
            } else if (respone.message === '秘钥可能已过期或接口已失效') {
              this.setCookie(2) // 类型2查询
            }
          }).catch((response:any) => {
            console.log('失败')
          })
        } else { // 没有查询到cookie，重新设置
          _self.setCookie(2)
        }
      }
    }
  }
  // 获取列表
  private async getCorpSelectList() {
    request({
      url: '/TCodecorp/GetTCodeSelectList',
      method: 'GET'
    }).then((respone:any) => {
      this.corpselectlist = respone.data
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  private addrselectlist = []
  private async getaddrselectlist() {
    request({
      url: '/TCodecorpmailaddr/GetSelectListByToken',
      method: 'GET'
    }).then((respone:any) => {
      this.addrselectlist = respone.data
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  private corpSelectloading=false
  private async getCorpSelectMethod(query) {
    if (query !== '') {
      this.corpSelectloading = true
      request({
        url: '/TCodecorp/GetTCodeSelectListWhere?wheres=' + encodeURI(query),
        method: 'GET'
      }).then((respone:any) => {
        this.corpselect = respone.data
      }).catch((response:any) => {
        console.log('失败')
      })
      this.corpSelectloading = false
    } else {
      this.corpSelectloading = false
      this.corpselect = []
    }
  }
  private provincechange(name:any) {
    let cityList = this.addList.data.filter(item => {
      return item.name === name
    })[0].pchilds
    this.cityList = cityList
    }

    private citychange(name:any) {
      let areaList = this.cityList.filter(item => {
        return item.name === name
      })[0].cchilds
      this.areaList = areaList
    }
}
